var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$o =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var shared$4 = {exports: {}};

var global$n = global$o;

var setGlobal$3 = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global$n, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$n[key] = value;
  } return value;
};

var global$m = global$o;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$m[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.16.2',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$4 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

var requireObjectCoercible$3 = requireObjectCoercible$4;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return Object(requireObjectCoercible$3(argument));
};

var toObject$5 = toObject$6;

var hasOwnProperty = {}.hasOwnProperty;

var has$a = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$5(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$l = global$o;

var aFunction$5 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$6 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$5(global$l[namespace]) : global$l[namespace] && global$l[namespace][method];
};

var getBuiltIn$5 = getBuiltIn$6;

var engineUserAgent = getBuiltIn$5('navigator', 'userAgent') || '';

var global$k = global$o;
var userAgent$3 = engineUserAgent;

var process$3 = global$k.process;
var Deno = global$k.Deno;
var versions = process$3 && process$3.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var fails$h = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$2 = engineV8Version;
var fails$g = fails$h;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$g(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$2 && V8_VERSION$2 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$j = global$o;
var shared$3 = shared$4.exports;
var has$9 = has$a;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$j.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$j = function (name) {
  if (!has$9(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has$9(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var wellKnownSymbol$i = wellKnownSymbol$j;

var TO_STRING_TAG$3 = wellKnownSymbol$i('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var redefine$8 = {exports: {}};

var fails$f = fails$h;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$f(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectDefineProperty = {};

var isObject$b = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var global$i = global$o;
var isObject$a = isObject$b;

var document$3 = global$i.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$a(document$3) && isObject$a(document$3.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$3.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$e = fails$h;
var createElement$1 = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$e(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var isObject$9 = isObject$b;

var anObject$c = function (it) {
  if (!isObject$9(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var getBuiltIn$4 = getBuiltIn$6;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var isSymbol$3 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$4('Symbol');
  return typeof $Symbol == 'function' && Object(it) instanceof $Symbol;
};

var isObject$8 = isObject$b;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && typeof (fn = input.toString) == 'function' && !isObject$8(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$8(val = fn.call(input))) return val;
  if (pref !== 'string' && typeof (fn = input.toString) == 'function' && !isObject$8(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var isObject$7 = isObject$b;
var isSymbol$2 = isSymbol$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$h = wellKnownSymbol$j;

var TO_PRIMITIVE = wellKnownSymbol$h('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$7(input) || isSymbol$2(input)) return input;
  var exoticToPrim = input[TO_PRIMITIVE];
  var result;
  if (exoticToPrim !== undefined) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject$7(result) || isSymbol$2(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol$1 = isSymbol$3;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol$1(key) ? key : String(key);
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var anObject$b = anObject$c;
var toPropertyKey$2 = toPropertyKey$3;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey$2(P);
  anObject$b(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;

var createNonEnumerableProperty$9 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$1.inspectSource != 'function') {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$h = global$o;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$h.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$2(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$g = global$o;
var isObject$6 = isObject$b;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var objectHas = has$a;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$g.WeakMap;
var set$1, get, has$8;

var enforce = function (it) {
  return has$8(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$6(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set$1 = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$8 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$8 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has$8,
  enforce: enforce,
  getterFor: getterFor
};

var global$f = global$o;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var has$7 = has$a;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$3 = internalState;

var getInternalState$4 = InternalStateModule$3.get;
var enforceInternalState$1 = InternalStateModule$3.enforce;
var TEMPLATE = String(String).split('String');

(redefine$8.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$7(value, 'name')) {
      createNonEnumerableProperty$7(value, 'name', key);
    }
    state = enforceInternalState$1(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global$f) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$7(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState$4(this).source || inspectSource$1(this);
});

var toString$7 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$7.call(it).slice(8, -1);
};

var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var classofRaw = classofRaw$1;
var wellKnownSymbol$g = wellKnownSymbol$j;

var TO_STRING_TAG$2 = wellKnownSymbol$g('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$6 = classof$7;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$6(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine$7 = redefine$8.exports;
var toString$6 = objectToString;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine$7(Object.prototype, 'toString', toString$6, { unsafe: true });
}

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var fails$d = fails$h;
var classof$5 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$d(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$5(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$3 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$4;

var toIndexedObject$5 = function (it) {
  return IndexedObject$3(requireObjectCoercible$2(it));
};

var DESCRIPTORS$4 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$3;
var has$6 = has$a;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$6(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$4 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$3 = toInteger$4;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$6 = function (argument) {
  return argument > 0 ? min$2(toInteger$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$2 = toInteger$4;

var max$1 = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$3 = function (index, length) {
  var integer = toInteger$2(index);
  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toLength$5 = toLength$6;
var toAbsoluteIndex$2 = toAbsoluteIndex$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = toLength$5(O.length);
    var index = toAbsoluteIndex$2(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var has$5 = has$a;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$5(hiddenKeys$2, key) && has$5(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$5(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$3 = getBuiltIn$6;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$a = anObject$c;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$3('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$a(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$4 = has$a;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$4 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$4.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$4(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$c = fails$h;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$c(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var global$e = global$o;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var redefine$6 = redefine$8.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$2 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$e;
  } else if (STATIC) {
    target = global$e[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$e[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$6(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$6(target, key, sourceProperty, options);
  }
};

var global$d = global$o;

var nativePromiseConstructor = global$d.Promise;

var redefine$5 = redefine$8.exports;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$5(target, key, src[key], options);
  return target;
};

var isObject$5 = isObject$b;

var aPossiblePrototype$1 = function (it) {
  if (!isObject$5(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

/* eslint-disable no-proto -- safe */

var anObject$9 = anObject$c;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$9(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$2 = objectDefineProperty.f;
var has$3 = has$a;
var wellKnownSymbol$f = wellKnownSymbol$j;

var TO_STRING_TAG$1 = wellKnownSymbol$f('toStringTag');

var setToStringTag$3 = function (it, TAG, STATIC) {
  if (it && !has$3(it = STATIC ? it : it.prototype, TO_STRING_TAG$1)) {
    defineProperty$2(it, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var getBuiltIn$2 = getBuiltIn$6;
var definePropertyModule$3 = objectDefineProperty;
var wellKnownSymbol$e = wellKnownSymbol$j;
var DESCRIPTORS$3 = descriptors;

var SPECIES$5 = wellKnownSymbol$e('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$3.f;

  if (DESCRIPTORS$3 && Constructor && !Constructor[SPECIES$5]) {
    defineProperty(Constructor, SPECIES$5, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var aFunction$4 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var anInstance$1 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var iterators = {};

var wellKnownSymbol$d = wellKnownSymbol$j;
var Iterators$4 = iterators;

var ITERATOR$5 = wellKnownSymbol$d('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$5] === it);
};

var aFunction$3 = aFunction$4;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$3(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var classof$4 = classof$7;
var Iterators$3 = iterators;
var wellKnownSymbol$c = wellKnownSymbol$j;

var ITERATOR$4 = wellKnownSymbol$c('iterator');

var getIteratorMethod$1 = function (it) {
  if (it != undefined) return it[ITERATOR$4]
    || it['@@iterator']
    || Iterators$3[classof$4(it)];
};

var anObject$8 = anObject$c;

var iteratorClose$1 = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject$8(returnMethod.call(iterator)).value;
  }
};

var anObject$7 = anObject$c;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var toLength$4 = toLength$6;
var bind$3 = functionBindContext;
var getIteratorMethod = getIteratorMethod$1;
var iteratorClose = iteratorClose$1;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate$1 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$3(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$7(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength$4(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

var wellKnownSymbol$b = wellKnownSymbol$j;

var ITERATOR$3 = wellKnownSymbol$b('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$3] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$3] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var anObject$6 = anObject$c;
var aFunction$2 = aFunction$4;
var wellKnownSymbol$a = wellKnownSymbol$j;

var SPECIES$4 = wellKnownSymbol$a('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$6(O).constructor;
  var S;
  return C === undefined || (S = anObject$6(C)[SPECIES$4]) == undefined ? defaultConstructor : aFunction$2(S);
};

var getBuiltIn$1 = getBuiltIn$6;

var html$2 = getBuiltIn$1('document', 'documentElement');

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var classof$3 = classofRaw$1;
var global$c = global$o;

var engineIsNode = classof$3(global$c.process) == 'process';

var global$b = global$o;
var fails$b = fails$h;
var bind$2 = functionBindContext;
var html$1 = html$2;
var createElement = documentCreateElement$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$2 = engineIsNode;

var set = global$b.setImmediate;
var clear = global$b.clearImmediate;
var process$2 = global$b.process;
var MessageChannel = global$b.MessageChannel;
var Dispatch = global$b.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$b.location;
} catch (error) { /* empty */ }

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$b.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var argumentsLength = arguments.length;
    var i = 1;
    while (argumentsLength > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE$2) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$2(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$b.addEventListener &&
    typeof postMessage == 'function' &&
    !global$b.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$b(post)
  ) {
    defer = post;
    global$b.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$a = global$o;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$a.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$9 = global$o;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$1 = engineIsNode;

var MutationObserver = global$9.MutationObserver || global$9.WebKitMutationObserver;
var document$2 = global$9.document;
var process$1 = global$9.process;
var Promise$1 = global$9.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$9, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$1 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = promise.then;
    notify$1 = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE$1) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$1 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global$9, flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aFunction$1 = aFunction$4;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$1(resolve);
  this.reject = aFunction$1(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$5 = anObject$c;
var isObject$4 = isObject$b;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$5(C);
  if (isObject$4(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$8 = global$o;

var hostReportErrors$1 = function (a, b) {
  var console = global$8.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var engineIsBrowser = typeof window == 'object';

var $$9 = _export;
var global$7 = global$o;
var getBuiltIn = getBuiltIn$6;
var NativePromise = nativePromiseConstructor;
var redefine$4 = redefine$8.exports;
var redefineAll = redefineAll$1;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$3;
var setSpecies$1 = setSpecies$2;
var isObject$3 = isObject$b;
var aFunction = aFunction$4;
var anInstance = anInstance$1;
var inspectSource = inspectSource$3;
var iterate = iterate$1;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var InternalStateModule$2 = internalState;
var isForced$1 = isForced_1;
var wellKnownSymbol$9 = wellKnownSymbol$j;
var IS_BROWSER = engineIsBrowser;
var IS_NODE = engineIsNode;
var V8_VERSION$1 = engineV8Version;

var SPECIES$3 = wellKnownSymbol$9('species');
var PROMISE = 'Promise';
var getInternalState$3 = InternalStateModule$2.get;
var setInternalState$2 = InternalStateModule$2.set;
var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromiseConstructorPrototype = NativePromisePrototype;
var TypeError$1 = global$7.TypeError;
var document$1 = global$7.document;
var process = global$7.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$7.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced$1(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION$1 === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION$1 >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$3] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject$3(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$7.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$7['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global$7, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global$7, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState$3(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromiseConstructorPrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructorPrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$3(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine$4(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine$4(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$2) {
      setPrototypeOf$2(NativePromisePrototype, PromiseConstructorPrototype);
    }
  }
}

$$9({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies$1(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$$9({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$$9({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$9({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var classof$2 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(arg) {
  return classof$2(arg) == 'Array';
};

var isObject$2 = isObject$b;
var isArray = isArray$1;
var wellKnownSymbol$8 = wellKnownSymbol$j;

var SPECIES$2 = wellKnownSymbol$8('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject$2(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$2 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind = functionBindContext;
var IndexedObject$2 = indexedObject;
var toObject$4 = toObject$6;
var toLength$3 = toLength$6;
var arraySpeciesCreate$1 = arraySpeciesCreate$2;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$4($this);
    var self = IndexedObject$2(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength$3(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$1;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

var fails$a = fails$h;
var wellKnownSymbol$7 = wellKnownSymbol$j;
var V8_VERSION = engineV8Version;

var SPECIES$1 = wellKnownSymbol$7('species');

var arrayMethodHasSpeciesSupport$3 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails$a(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$8 = _export;
var $map = arrayIteration.map;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$3;

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$2('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$8({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var fails$9 = fails$h;

var arrayMethodIsStrict$2 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$9(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $$7 = _export;
var IndexedObject$1 = indexedObject;
var toIndexedObject$1 = toIndexedObject$5;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$2;

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject$1 != Object;
var STRICT_METHOD$1 = arrayMethodIsStrict$1('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$$7({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$1 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject$1(this), separator === undefined ? ',' : separator);
  }
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict = arrayMethodIsStrict$2;

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var global$6 = global$o;
var DOMIterables$1 = domIterables;
var forEach = arrayForEach;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;

for (var COLLECTION_NAME$1 in DOMIterables$1) {
  var Collection$1 = global$6[COLLECTION_NAME$1];
  var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype$1 && CollectionPrototype$1.forEach !== forEach) try {
    createNonEnumerableProperty$5(CollectionPrototype$1, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype$1.forEach = forEach;
  }
}

var $$6 = _export;
var $filter = arrayIteration.filter;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$3;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$6({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var styleId = 'tts-player-css';

function checkCssExist() {
  if (typeof document === 'undefined') {
    return false;
  }

  return !!document.getElementById(styleId);
}

function insertCss(css) {
  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  style.dataset.for = 'result';
  style.id = 'tts-player-css';
  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

function styleInject(css) {
  if (checkCssExist()) {
    return;
  }

  insertCss(css);
}

var css_248z = "._2lMH_{bottom:0;left:50%;margin:auto 0;position:fixed;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:100%;z-index:100000}._29hoo{-webkit-box-orient:vertical;-webkit-box-direction:normal;background-color:#fff;border-radius:12px;-webkit-box-shadow:0 2px 10px 0 rgba(0,0,0,.3);box-shadow:0 2px 10px 0 rgba(0,0,0,.3);-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:102px;padding-top:16px;position:absolute;width:368px}._29hoo.adJuL{width:288px}._29hoo.adJuL ._24ewg{width:50px}._29hoo.adJuL ._2hDe0{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAoBAMAAABtB+WqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURQAAAEdwTJ2dnQAAAPT09E5OTgAAAAAAANra2sXFxYKCgunp6f///8jW898AAAAMdFJOU2YAol3wfEAN0L2T4VOWEqYAAABeSURBVCjPYxBPZkACZoUMxQwowJwhAVWAjcEAVYCZgc4gcgEqn9XHAVUg5MwENAUn0BU0UFkBw5zTaK5cc0YBVYDpzCE0JTq0UoIWHgwqExgGEmAkGIwkhZHo0JMlAE9xHOcjkapKAAAAAElFTkSuQmCC);left:0}._29hoo.adJuL ._2hDe0:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAoCAMAAACo9wirAAAANlBMVEUAAACDg4Pv7+8AAAAAAAA7OzsKCgrLy8sAAADKysqvr681NTXg4OC8vLyoqKhra2tlZWX///+X5qddAAAAEXRSTlOZwfWSZKib4Abf0qfr2M+3tXPw/HAAAABWSURBVDjL7dS5EYAwEENR7QEYm0v9N0sF7A7DkIB/+hQLxQ2XmRc4whyGMMNva/UIfVBq4lwTn8dnPr3oLXFUcokcO0lBlHxroQgT3dC7+zGWnlh6gyfN0QQRsAhCegAAAABJRU5ErkJggg==);cursor:pointer}._29hoo.adJuL ._3Boe7{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAoBAMAAABtB+WqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURQAAAEdwTJ2dnQAAAPT09E5OTgAAAAAAANra2sXFxYKCgunp6f///8jW898AAAAMdFJOU2YAol3wfEAN0L2T4VOWEqYAAABdSURBVCjPYxBPZkACZoUMxQwowJwhAVWAjcEAVYCZgY6AayqaAMuRAFQBzjOuaEp60JVw0EjJnpOofKYzp1AFdM4ooCk4RG0FLGgKGDidGAYaYCQYjCSFkejQkyUATP8cFT8mlqYAAAAASUVORK5CYII=);right:0}._29hoo.adJuL ._3Boe7:hover{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAoCAMAAACo9wirAAAAPFBMVEUAAACEhITw8PAAAAAAAAA7OzsKCgrLy8sAAACvr6+AgIA1NTXt7e3g4ODKysq8vLyoqKhra2tlZWX////7b8t+AAAAE3RSTlOZwfWSZKib4AbSv6fz69/Yz7e1HqwOCgAAAFdJREFUOMvt1LkRgDAQQ1HhXcAHt/rvlQq8Sj0DL/2KheyGLvMMR8hhCBm+5ykNocQ0I3JSLJZDLtaBFi1c7GRBYCJ5iz4N3KvoSKLj2ip+PSayPDF5gy/hQgSHo210UwAAAABJRU5ErkJggg==);cursor:pointer}._29hoo.adJuL ._3dS1j{background-position:0 0;background-repeat:no-repeat;background-size:cover;height:20px;position:absolute;top:65px;width:16px}._29hoo._1g-Xw{height:238px}._29hoo ._3mirU{display:block;opacity:.8}._29hoo ._3AfHm{cursor:default;opacity:.3}._29hoo ._1Lxea,._29hoo ._2SZq2:hover{cursor:pointer;opacity:1}._29hoo ._1Lxea{position:relative}._29hoo ._1Lxea:after{background-color:hsla(0,0%,100%,.1);background-size:cover;border-radius:8px;content:\"\";display:block;height:22px;left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:22px}._29hoo ._27VLw{border-radius:12px;height:100%;left:0;overflow:hidden;position:absolute;top:0;width:100%;z-index:1}._29hoo ._1fb4H{background-color:rgba(51,51,51,.6);border-radius:12px;z-index:2}._29hoo ._1fb4H,._29hoo .vPGr9{bottom:0;left:0;position:absolute;right:0;top:0}._29hoo .vPGr9{background-image:url(data:image/png;base64,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);background-repeat:no-repeat;background-size:cover;-webkit-filter:blur(15px);filter:blur(15px);overflow:hidden;z-index:1}._29hoo .DGD48{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin-bottom:12px;padding:0 32px 0 16px;position:relative;z-index:3}._29hoo ._1Zy0R{-ms-flex-negative:0;-webkit-flex-shrink:0;flex-shrink:0;height:38px;margin-right:8px;position:relative;width:38px}._29hoo ._1Zy0R:after{border:1px solid hsla(0,0%,100%,.1);border-radius:8px;content:\"\";display:block;height:100%;left:-1px;position:absolute;top:-1px;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0;width:100%;z-index:1000}._29hoo ._1Uq60{border-radius:8px;display:block;height:100%;left:0;overflow:hidden;position:absolute;top:0;width:100%}._29hoo .mS2cs{-ms-flex-negative:0;-webkit-flex-shrink:0;flex-shrink:0;height:auto}._29hoo._2c_jp ._1BB3Z,._29hoo.G-kl- ._1Swet,._29hoo .mS2cs{border-radius:8px;left:50%;position:absolute;top:0;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:100%}._29hoo._2c_jp ._1BB3Z,._29hoo.G-kl- ._1Swet{background-color:rgba(0,0,0,.5);height:100%;z-index:5}._29hoo._2c_jp ._1BB3Z:after,._29hoo.G-kl- ._1Swet:after{background-position:0 0;background-repeat:no-repeat;background-size:cover;content:\"\";display:block;height:24px;left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:24px;z-index:10}._29hoo.G-kl- ._1Swet:after{background-image:url(data:image/gif;base64,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)}._29hoo._2c_jp ._1BB3Z:after{background-image:url(https://b.bdstatic.com/searchbox/icms/searchbox/img/pc_tts_loading.gif)}._29hoo .yxuhE{-webkit-box-orient:vertical;-webkit-line-clamp:2;color:#fff;display:-webkit-box;font-size:14px;line-height:1.5;margin-bottom:-5px;margin-top:-5px;overflow:hidden;position:relative;text-align:left;text-overflow:ellipsis;width:100%}._29hoo .yxuhE._1-JZp{height:34px}._29hoo .yxuhE._1-JZp:after{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQIAAAAiAgMAAADJ+j9BAAAADFBMVEX///////////8AAAD1GyhhAAAABHRSTlMIFxkA9E5SmAAAAEpJREFUeAFjkFpFGXBgyKLQhAkMqygEC6hswqgJoyZQnqopz1n/KQQfqGbCqAmEY3MJARMIp6iV+E0gJlXT04RRE0ZNoDxVU56zACOCwvuGsq9tAAAAAElFTkSuQmCC);background-size:cover;border-radius:2px;content:\"\";display:block;height:34px;left:0;position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:258px}._29hoo .yxuhE:hover{cursor:pointer}._29hoo ._2_rJ6{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURf///0dwTP///////////////////////////////////////////////zbjKbUAAAANdFJOUwEAJPI6552cStiLq2Woe3PGAAAAnUlEQVQY02WQsQkCYQyFc1d4gk1uBIu/ECwsXOAGOXABwQUEF7AQXECcx0rQ4ni7mPdyyImp8vFBXhJrJ2W/MD9lt14GnN8V+7q/EHAgFBAaUNX9swvwI1XBVtOoJAhUEsppMEgIQknkBgug+0JBZpnCgVc1QozaY5fAjJmUZbhLWW7VSlluRXULeCg81CZgddWhfqfx8QH+95BJfQBZdj+u6kgOxQAAAABJRU5ErkJggg==) 50% no-repeat;background-size:12px 12px;height:12px;opacity:.8;padding:6px;position:absolute;right:2px;top:2px;width:12px;z-index:3}._29hoo ._3dXp6{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-justify-content:space-between;justify-content:space-between;padding:0 16px;position:relative;width:100%;z-index:4}._29hoo ._2CGLg{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTP///////////////////////////////////////////////////////////////8/RimEAAAAQdFJOUwA0Ycd2Bxv26quMELfWnE+dQo3gAAABUUlEQVRIx51WgbKEIAhUEzGt5P+/9oF5U/muknPmZm6ShWVF0Jh+QUnLGhHjuqQC5mVlNyOdFs4uP5iDb9bsnaM0jL8LA66aTN42C7B+qnD31T7IZvSh++rFyxT+21vewPSFcE7MM9r+s8Pvfj6xsaPlOO52qyFsvH1BWPbvn+T2HOPEKsQX+4qIB2PmuL0dKbOaTglMrzUgXlsaEAnDq70JSBE+9JIZWKklmhl5OS9bWrxQLseVmUneM/Cdo11B0Tp1SkkWM9ElAynYrelCeMmCaOaU8ZCrLqnP2eyeiDqhEEzpz+wBwJyKULajACtJLUQwCgCixawUzSjARFrrbxgg3pGjDAMW1lkNUFNSJ62WVX1w6tJQF5+6vPUX6PaKws0VVTcBfZsZa2RwNLL6X9Uq9c1YFERNu9cPFP3I0g9F/dgVWrrBrn86/PA4GXn+/AFGkx/SqKgjjQAAAABJRU5ErkJggg==) 0 0 no-repeat;background-size:cover;height:24px;width:24px}._29hoo ._2CGLg._3yeus{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTP///////////////////////////////////////////////////////////////////4ZSzFsAAAARdFJOUwAvjcq7GmDq9gcQpXfWbUt8rYduugAAAVJJREFUSMedVtm2wyAIdBfUNOH/f7Zo0tvEaxbKOXmJDAyrKtULzsZNESBOzsyobiSFDLQTyCFdqOOyabN19rJhljM3GJqKLXrTQF1sg4ehvq+Hsfjub6lWrP+vr/kAzIBwMswz6v534L/Oj7l6x7Y6WoH95tMcYubjA0Kz/ddVul/sY8fKxxv9hohfxpyffFdSZmV3AbjbHkD3FwZGAq9uxQPF1exCZNQDMURLKwwj0xNAYiZpjaB0dQI7jxBljYLDP0bgasPlQVS+JRPhm65V1haPg8JYAlRzz0h9hsfqAae5xq7HAE5elwxd88mM8QzQjw5yhdVEUZ0CWOHgPtLUvgvAcXSqdWAvV4BDFzgCOUBMSRy0OK3iwolbQ9x84vYeDpC7GiDxiIqXgHzNiBeZQumqlC9j8bqXXyjyK0t+Kcqv3RqZ7GKXPx1+eJw8ef68AR8+IxSCShR0AAAAAElFTkSuQmCC) 0 0 no-repeat;background-size:cover;height:24px;width:24px}._29hoo ._1keAE{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTP///////////////////////////////////////////////////4sGkswAAAANdFJOUwDkIfZNbtYMgDqjBsifXeqhAAAAa0lEQVQoz2NgoAZgClWAsx1FgMTkuxYbYAKyF4HE2bt3M2ECd++Cibt3l6MLXHRAE7h7SwFN4K4pusDdQ+gCl7vRBO5eU0ATuCuOLnCFoIA4AUMxrD1EwOnonkPxvi16AGEEIUYgY0QD5QAA86Ojm4AZawAAAAAASUVORK5CYII=) 0 0 no-repeat;background-size:16px 16px;height:16px;width:16px}._29hoo ._1MRZ3{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTP///////////////////////////////////////////////////////////////8/RimEAAAAQdFJOUwAuT2UdlcfjBBBDrPm8gNZg1wMaAAABAklEQVQ4y5VT27aFIAiMvISXlP//2g1uSys662weWthMOAy0LL9FAAjvKBpPHN6gjtsGN4pV8U2w7fvUGDsDhQXYwsn+xFd+vS440nskInfkjig9CHw3HDmwikeLRPnoDjET4ZNAp0WBD9oV8cijcoUI870s+knwMgkj1xjI3CH4UoKqiWAqaQW6lT2SMi5IJ5yL8vmaO5h90SZVWuFo31ZFxlOHcLQlXheNXdrnVfOU56M0voWbrfbN5kEwzg4T61kNKpsgBBhLYefZJNkmIcRp8fhs/iSIC95JgE7A84/YdAI32p32X0K9E9ir1UgEHgpbUhgLdQi72iqjbraFf/3vH4MNEHFb8PieAAAAAElFTkSuQmCC) 0 0 no-repeat;background-size:16px 16px;height:16px;width:16px}._29hoo ._3pr3i{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURf///0dwTP///////////////////////////////////////////////////////yMjVUcAAAAPdFJOU4AADOlNOyGxX8Fs0ouV4LpVCSQAAADaSURBVCjPldE7CsJAEAbgOYCwjhixsRAFwcJC7IN4gOAJJJWdwcZeLxA8geANPIF4BE9gZS/GIMHH72Y3SCaVTrffso9/hrhQ9DM4vgRnHwuonHARMIKEKeB+oUpUAgbKQGfB5EHXq2khfDRJ6fVjzBYCHEglREtOYXbmOvpkt1II38z7Ww5aWLJ65qCMI3v3HDhY8yTJQQ07CVXM5ZEGDvLSAEP5bJjoe6/mpysDOlkPR5Ml2mZZVOTbtNE2g5vth4toY6A7th3ruoUWpiJBS1wYVNv/e7bf+gChqIbKQjrjggAAAABJRU5ErkJggg==) 0 0 no-repeat;background-size:16px 16px;height:16px;width:16px}._29hoo._2nEKW ._3pr3i,._29hoo._2nEKW ._3rM0s{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAgOUKff3Uw5ZkGG04BtCnEPntSkMex8CpinNcVEgwIfTJsybGR/lLAAAAyklEQVQ4y72SSQ6DMAxFTRLmQJlbWqCT73/GmkQ0i+IsuuBJIMR/8IMJHE/39sa6xHrh4yoJEVGx+SRwJWDi/oVEsyPMamV8UCym4FeYcSNMKjBClmZ2TWlPZ7XlpQawQozNna4zgZG9dQ6IWwFOwFJCEaMRXOtX0DXiCRIq7fYFSKnxQscVGME8vb6FFYoBESPpEZ5W+KvCv0j/Z/KDspOUwI7aInIJez+rpcwprtDRqoAYhVEGfkfJ3ChG8CsKwKuEGnzIdoHD+QDqhx659rKf7AAAAABJRU5ErkJggg==)}._29hoo ._3rM0s{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURf///0dwTP///////////////////////////////////////////////////////yMjVUcAAAAPdFJOU4AADOlNOyGxX8Fs0ouV4LpVCSQAAADaSURBVCjPldE7CsJAEAbgOYCwjhixsRAFwcJC7IN4gOAJJJWdwcZeLxA8geANPIF4BE9gZS/GIMHH72Y3SCaVTrffso9/hrhQ9DM4vgRnHwuonHARMIKEKeB+oUpUAgbKQGfB5EHXq2khfDRJ6fVjzBYCHEglREtOYXbmOvpkt1II38z7Ww5aWLJ65qCMI3v3HDhY8yTJQQ07CVXM5ZEGDvLSAEP5bJjoe6/mpysDOlkPR5Ml2mZZVOTbtNE2g5vth4toY6A7th3ruoUWpiJBS1wYVNv/e7bf+gChqIbKQjrjggAAAABJRU5ErkJggg==) 0 0 no-repeat;background-size:16px 16px;bottom:10px;height:16px;left:50%;position:absolute;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:16px}._29hoo ._2emlj{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-negative:0;-webkit-box-align:center;-ms-flex-align:center;-webkit-box-pack:justify;-ms-flex-pack:justify;-webkit-align-items:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-shrink:0;flex-shrink:0;-webkit-justify-content:space-between;justify-content:space-between}._29hoo ._24ewg{background-color:hsla(0,0%,100%,.16);border-radius:1px;height:2px;margin-right:8px;position:relative;width:126px}._29hoo .xsQyG{background-color:hsla(0,0%,100%,.6);border-radius:1px;height:100%;left:0;position:absolute;top:0}._29hoo ._2I2N3,._29hoo .xIoYh{color:hsla(0,0%,100%,.7);cursor:default;font-size:12px;font-weight:200;line-height:1;width:32px}._29hoo ._3FpGf{position:relative}._29hoo ._1Lv75{background:#333;border-radius:12px;bottom:26px;-webkit-box-shadow:0 2px 10px 0 rgba(0,0,0,.3);box-shadow:0 2px 10px 0 rgba(0,0,0,.3);display:none;height:116px;width:30px;z-index:4}._29hoo ._1Lv75,._29hoo ._26Shv{left:50%;position:absolute;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%)}._29hoo ._26Shv{background-color:hsla(210,1%,72%,.3);border-radius:2px;bottom:31px;cursor:pointer;height:75px;width:4px}._29hoo ._2iH-v{border-radius:2px;left:0;width:100%}._29hoo ._2iH-v,._29hoo .NZ1fB{background-color:#fff;bottom:0;position:absolute}._29hoo .NZ1fB{border-radius:50%;cursor:pointer;left:50%;-webkit-transform:translate(-50%);-ms-transform:translate(-50%);transform:translate(-50%);-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;z-index:1}._29hoo .NZ1fB:hover{-webkit-transform:translate(-50%) scale(1.6);-ms-transform:translate(-50%) scale(1.6);transform:translate(-50%) scale(1.6)}._29hoo ._2I2N3{margin-right:8px}._29hoo ._1M48y{-webkit-box-orient:vertical;background:rgba(0,0,0,.2);-webkit-box-sizing:border-box;box-sizing:border-box;display:none;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:124px;margin-bottom:12px;padding:12px 16px 0 12px;position:relative;z-index:3}._29hoo ._1M48y,._29hoo ._3g6Hz{-webkit-box-direction:normal;width:100%}._29hoo ._3g6Hz{-webkit-box-orient:horizontal;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row}._29hoo ._2rUmK{color:#fff;font-size:14px;line-height:1;margin-right:6px}._29hoo ._16XCR{color:#fff;font-size:12px;font-weight:200;line-height:14px;opacity:.7}._29hoo ._3uiQc{background:hsla(0,0%,100%,.1);border-radius:9px;color:#fff;cursor:pointer;font-size:12px;font-weight:400;height:18px;line-height:18px;position:absolute;right:8px;text-align:center;top:16px;width:40px}._29hoo .nWBd1{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;position:relative;width:56px}._29hoo .nWBd1._13Usk .PY9AU,._29hoo .nWBd1._13Usk .VY6Gt{display:block}._29hoo .nWBd1._13Usk ._3OUcG{opacity:1}._29hoo .nWBd1:hover .VY6Gt{display:block}._29hoo .nWBd1:hover ._3OUcG{opacity:1}._29hoo .nWBd1:not(:last-child){margin-right:14px}._29hoo .VY6Gt{border:2px solid #315efb;border-radius:10px;-webkit-box-sizing:content-box;box-sizing:content-box;display:none;height:50px;left:50%;position:absolute;top:-3px;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:50px}._29hoo ._1ljTf{-ms-overflow-style:none;-webkit-box-orient:horizontal;-webkit-box-direction:normal;scrollbar-height:none;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;height:70px;overflow-x:scroll;overflow-y:visible;padding-top:16px;scrollbar-width:none}._29hoo ._1ljTf::-webkit-scrollbar{background:transparent;height:0;width:0}._29hoo .mH2VU{border-radius:8px;height:48px;margin-bottom:8px;width:48px}._29hoo .PY9AU{background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURUdwTDNf/TNg/TFf/DFf/DVh/zdp/zFe/DFf/DFe/DNe/TFf/DJe/DZi/zFe+////7XF/aW5/cfU/mqL/Ddj+5Ss/e3x/lXfZe0AAAAOdFJOUwBbRfvuGguX2vV0wLYvfoQSDAAAAL1JREFUKM9tklkWwyAIRZ1BY8mc/S+1YDOo6fswx/siIKjUTz5ljA6z9qqWB0unLFSWjlTJmYsnamX1+T/1suWMj2/DBTago+vKC/AB2/JpHNmJoc88j8UgrXLZbxWfqMRCwcext5wGJTWtvN8bTqicfBYmc83ZwJJCnKXiHCrfVYp3FcHJz4Zsc8PJPBfcj+nh0hOgP0rSRPfmKE1UxvY8fs6BdE68R2iaaPh5hh7gnpZLoXknQcOAOIC58BembBh83jJfWAAAAABJRU5ErkJggg==\") no-repeat 0 0;background-size:cover;display:none;height:14px;position:absolute;right:0;top:-7px;width:14px}._29hoo ._3OUcG{color:#fff;font-size:13px;font-weight:200;line-height:1;opacity:.7;white-space:nowrap}@media (-webkit-min-device-pixel-ratio:1.5),(min-device-pixel-ratio:1.5){._29hoo ._1Zy0R:after{border-radius:16px;height:200%;left:0;top:0;-webkit-transform:scale(.5) translate(-1px,-1px);-ms-transform:scale(.5) translate(-1px,-1px);transform:scale(.5) translate(-1px,-1px);width:200%}}@media (-webkit-min-device-pixel-ratio:2.9),(min-device-pixel-ratio:2.9){._29hoo ._1Zy0R:after{border-radius:24px;height:300%;left:0;top:0;-webkit-transform:scale(.3333) translate(-1px,-1px);-ms-transform:scale(.3333) translate(-1px,-1px);transform:scale(.3333) translate(-1px,-1px);width:300%}}";
var styles = {"pcTtsFixContainer":"_2lMH_","pcTtsContainer":"_29hoo","pcTtsSmall":"adJuL","pcTtsProgressBarContainer":"_24ewg","pcTtsVoiceChooseLeftIcon":"_2hDe0","pcTtsVoiceChooseRightIcon":"_3Boe7","pcTtsVoiceChooseIcon":"_3dS1j","pcTtsShowingChoose":"_1g-Xw","pcTtsIcon":"_3mirU","pcTtsDisableIcon":"_3AfHm","pcTtsEnableIcon":"_2SZq2","pcTtsActiveIcon":"_1Lxea","pcTtsBackgroundContainer":"_27VLw","pcTtsFront":"_1fb4H","pcTtsBackground":"vPGr9","pcTtsInfo":"DGD48","pcTtsImageContainer":"_1Zy0R","pcTtsImageWrapper":"_1Uq60","pcTtsImage":"mS2cs","pcTtsPlaying":"G-kl-","pcTtsPlayingAni":"_1Swet","pcTtsLoading":"_2c_jp","pcTtsLoadingAni":"_1BB3Z","pcTtsTitle":"yxuhE","pcTtsTitleDefault":"_1-JZp","pcTtsCloseBtn":"_2_rJ6","pcTtsTools":"_3dXp6","pcTtsPlayIcon":"_2CGLg","pcTtsContinueIcon":"_3yeus","pcTtsNextIcon":"_1keAE","pcTtsVoiceChangeIcon":"_1MRZ3","pcTtsVoiceColumnIcon":"_3pr3i","pcTtsMuted":"_2nEKW","pcTtsVoiceSubIcon":"_3rM0s","pcTtsProgressContainer":"_2emlj","pcTtsProgressBarInner":"xsQyG","pcTtsCurrentTimeText":"_2I2N3","pcTtsEndTimeText":"xIoYh","pcTtsVoiceColumnContainer":"_3FpGf","pcTtsVoiceColumn":"_1Lv75","pcTtsVoiceBar":"_26Shv","pcTtsVoiceActiveBar":"_2iH-v","pcTtsVoicePoint":"NZ1fB","pcTtsVoiceChooseContainer":"_1M48y","pcTtsVoiceChooseNotice":"_3g6Hz","pcTtsVoiceChooseTitle":"_2rUmK","pcTtsVoiceChooseTips":"_16XCR","pcTtsVoiceChooseCloseBtn":"_3uiQc","pcTtsVoiceItem":"nWBd1","pcTtsVoiceItemActive":"_13Usk","pcTtsVoiceItemHoverBorder":"VY6Gt","pcTtsVoiceChecked":"PY9AU","pcTtsVoiceItemTitle":"_3OUcG","pcTtsVoicesContainer":"_1ljTf","pcTtsVoiceItemImage":"mH2VU"};
styleInject(css_248z);

var isObject$1 = isObject$b;
var setPrototypeOf$1 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$1 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject$1(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};

var isObject = isObject$b;
var classof$1 = classofRaw$1;
var wellKnownSymbol$6 = wellKnownSymbol$j;

var MATCH$1 = wellKnownSymbol$6('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$1(it) == 'RegExp');
};

var isSymbol = isSymbol$3;

var toString$5 = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};

var anObject$4 = anObject$c;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$4(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$8 = fails$h;
var global$5 = global$o;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$5.RegExp;

regexpStickyHelpers.UNSUPPORTED_Y = fails$8(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$8(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var fails$7 = fails$h;
var global$4 = global$o;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$4.RegExp;

var regexpUnsupportedDotAll = fails$7(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$6 = fails$h;
var global$3 = global$o;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$3.RegExp;

var regexpUnsupportedNcg = fails$6(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

var DESCRIPTORS$2 = descriptors;
var global$2 = global$o;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
var defineProperty$1 = objectDefineProperty.f;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isRegExp = isRegexp;
var toString$4 = toString$5;
var getFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var redefine$3 = redefine$8.exports;
var fails$5 = fails$h;
var has$2 = has$a;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$2;
var wellKnownSymbol$5 = wellKnownSymbol$j;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol$5('match');
var NativeRegExp = global$2.RegExp;
var RegExpPrototype$2 = NativeRegExp.prototype;
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$2 &&
  (!CORRECT_NEW || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1 || fails$5(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      result += chr + string.charAt(++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      chr = chr + string.charAt(++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (IS_NCG.test(string.slice(index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || has$2(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named.push([groupname, groupid]);
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || pattern instanceof RegExpWrapper) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags.call(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$4(pattern);
    flags = flags === undefined ? '' : toString$4(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL$1 && 'dotAll' in re1) {
      dotAll = !!flags && flags.indexOf('s') > -1;
      if (dotAll) flags = flags.replace(/s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y$1 && 'sticky' in re1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    if (UNSUPPORTED_NCG$1) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$2, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty$4(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty$1(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype$2.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$2;
  redefine$3(global$2, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$1 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var anObject$3 = anObject$c;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$3(O);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);
  return O;
};

/* global ActiveXObject -- old IE, WSH */

var anObject$2 = anObject$c;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$2(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var toString$3 = toString$5;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create$2 = objectCreate;
var getInternalState$2 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$2(re);
    var str = toString$3(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = str.slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str.charAt(re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$5 = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$5({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var redefine$2 = redefine$8.exports;
var anObject$1 = anObject$c;
var $toString = toString$5;
var fails$4 = fails$h;
var flags = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$4(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$2(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$1(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype$1) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

// TODO: Remove from `core-js@4` since it's moved to entry points

var redefine$1 = redefine$8.exports;
var regexpExec$1 = regexpExec$2;
var fails$3 = fails$h;
var wellKnownSymbol$4 = wellKnownSymbol$j;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;

var SPECIES = wellKnownSymbol$4('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$4(KEY);

  var DELEGATES_TO_SYMBOL = !fails$3(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$3(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine$1(String.prototype, KEY, methods[0]);
    redefine$1(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype[SYMBOL], 'sham', true);
};

var toInteger$1 = toInteger$4;
var toString$2 = toString$5;
var requireObjectCoercible$1 = requireObjectCoercible$4;

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$2(requireObjectCoercible$1($this));
    var position = toInteger$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var classof = classofRaw$1;
var regexpExec = regexpExec$2;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$c;
var toLength$2 = toLength$6;
var toString$1 = toString$5;
var requireObjectCoercible = requireObjectCoercible$4;
var advanceStringIndex = advanceStringIndex$1;
var regExpExec = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString$1(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString$1(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString$1(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$2(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

/**
 * @private
 * @module dom
 * @category utils
 * @author leizhihao@baidu.com
 */

/**
 * 根据对象key value生成style对象
 * @param styleObj
 */
function getStyleString(styleObj) {
  var result = '';

  for (var i in styleObj) {
    result += i + ": " + styleObj[i] + ";";
  }

  return result;
}
/**
 * 递归查找子元素的父元素是否含有某css className
 * @param el 子html元素
 * @param className 查找的css class名
 */

function isParentHasClass(el, className) {
  while (el.parentElement) {
    if (el.classList.contains(className)) {
      return true;
    }

    el = el.parentElement;
  }

  return false;
}
/**
 * 递归查找子元素含有某css className的父元素
 * @param el 子HTML元素
 * @param className 查找的css class
 */

function findParent(el, className) {
  while (el.parentElement) {
    if (el.classList.contains(className)) {
      return el;
    }

    el = el.parentElement;
  }

  return null;
}
/**
 * 判断父节点是否含有某子节点
 * @param parent
 * @param child
 */

function isParentHasChild(parent, child) {
  var childNodes = parent.childNodes;

  for (var i = 0; i < childNodes.length; i++) {
    if (childNodes[i] === child) {
      return true;
    }
  }

  return false;
}
function removeChild(parent, child) {
  if (isParentHasChild(parent, child)) {
    parent.removeChild(child);
  }
}
/**
 * nextTick，用setTimeout实现，一般用于原生HTML元素修改后的后续操作
 * @param timeout timeout时间
 */

function nextTick(timeout) {
  if (timeout === void 0) {
    timeout = 0;
  }

  return new Promise(function (resolve) {
    window.setTimeout(resolve, timeout);
  });
}
/**
 * 查找cookie名的value
 * @param name 查找的cookie名字
 */

function getCookie(name) {
  var arr;
  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return '';
}
/**
 * 阻止事件冒泡
 */

function stopEventPop(event) {
  if (typeof event.stopPropagation === 'function') {
    event.stopPropagation();
  } else {
    event.cancelBubble = true;
  }
}

var paramsToString = function paramsToString(params) {
  var result = '';

  for (var i in params) {
    result += i + "=" + params[i] + "&";
  }

  return result;
}; // 格式化时间

var formatTime = function formatTime(duration) {
  var min = Math.floor(duration / 60);
  var sec = Math.floor(duration - min * 60);
  return (min < 10 ? '0' + min : min) + ":" + (sec < 10 ? '0' + sec : sec);
};

/**
 * @public
 * @module types
 * @category types
 * @author leizhihao@baidu.com
 */

/** 报错类型 */
var ErrorType;

(function (ErrorType) {
  /** 网络错误 */
  ErrorType["NET_WORK_ERROR"] = "netWorkError";
  /** 加载资源失败 */

  ErrorType["LOAD_ERROR"] = "loadError";
  /** 更新音色失败 */

  ErrorType["UPDATE_VOICE_ERROR"] = "updateVoiceError";
  /** 未知错误 */

  ErrorType["UNKNOWN_ERROR"] = "unknownError";
})(ErrorType || (ErrorType = {}));
/**
 * TtsPlayerCore会抛出的事件
 * @private
 * @enum {string}
 * @readonly
 */


var CoreEvents;

(function (CoreEvents) {
  /** 音色列表改变 */
  CoreEvents["LOAD_VOICES"] = "loadVoices";
  /** 播放结束 */

  CoreEvents["PLAY_END"] = "playEnd";
  /** 播放结束 */

  CoreEvents["PAUSE"] = "pause";
  /** 继续播放 */

  CoreEvents["PLAY"] = "play";
  /** 开始播放 */

  CoreEvents["START_PLAY"] = "startPlay";
  /** 禁用下一曲 */

  CoreEvents["DISABLE_NEXT"] = "disableNext";
  /** 可以使用下一曲 */

  CoreEvents["ENABLE_NEXT"] = "enableNext";
  /** 更新已播放时长 */

  CoreEvents["UPDATE_DURATION"] = "updateDuration";
  /** id切换 */

  CoreEvents["CHANGE_ID"] = "changeId";
  /** 段落切换 */

  CoreEvents["CHANGE_PARAGRAPH"] = "changeParagraph";
  /** 出现错误 */

  CoreEvents["ERROR"] = "error";
  /** 资源信息加载开始 */

  CoreEvents["LOAD_SOURCE_START"] = "loadSourceStart";
  /** 资源信息加载完毕 */

  CoreEvents["LOAD_SOURCE_COMPLETE"] = "loadSourceComplete";
})(CoreEvents || (CoreEvents = {}));
/**
 * @private
 * UI界面的各种事件
 */


var PlayerUIEvents;

(function (PlayerUIEvents) {
  /** 点击暂停 */
  PlayerUIEvents["PAUSE_CLICK"] = "pauseClick";
  /** 点击继续 */

  PlayerUIEvents["CONTINUE_CLICK"] = "continueClick";
  /** 点击下一首 */

  PlayerUIEvents["NEXT_CLICK"] = "nextClick";
  /** 点击更改音色Icon */

  PlayerUIEvents["VOICE_CHANGE_CLICK"] = "voiceChangeClick";
  /** 点击音量icon */

  PlayerUIEvents["VOICE_COLUMN_CLICK"] = "voiceColumnClick";
  /** 点击关闭按钮 */

  PlayerUIEvents["CLOSE_CLICK"] = "closeClick";
  /** 音量改变 */

  PlayerUIEvents["VOLUME_CHANGE"] = "volumeChange";
  /** 音色改变 */

  PlayerUIEvents["VOICE_CHOOSE"] = "voiceChoose";
  /** 点击标题 */

  PlayerUIEvents["CLICK_TITLE"] = "clickTitle";
  /** 播放器展示 */

  PlayerUIEvents["SHOW_PLAYER"] = "showPlayer";
})(PlayerUIEvents || (PlayerUIEvents = {}));
/**
 * @public
 * 使用此播放器的开发者用的事件
 */


var PlayerEvents;

(function (PlayerEvents) {
  /** 播放结束 */
  PlayerEvents["PLAY_END"] = "playEnd";
  /** 切换段落 */

  PlayerEvents["CHANGE_PARAGRAPH"] = "changeParagraph";
  /** 开始播放 */

  PlayerEvents["START_PLAY"] = "startPlay";
  /** 播放按钮点击 */

  PlayerEvents["PLAY_CLICK"] = "playClick";
  /** 暂停按钮点击 */

  PlayerEvents["PAUSE_CLICK"] = "pauseClick";
  /** 开始播放一段音频 */

  PlayerEvents["PLAY"] = "play";
  /** 暂停 */

  PlayerEvents["PAUSE"] = "pause";
  /** 点击title */

  PlayerEvents["CLICK_TITLE"] = "clickTitle";
  /** 报错 */

  PlayerEvents["ERROR"] = "error";
})(PlayerEvents || (PlayerEvents = {}));
/**
 * @private
 * 打点类型
 */


var LOG_TYPE;

(function (LOG_TYPE) {
  /** 展现 */
  LOG_TYPE["SHOW"] = "1";
  /** 点击 */

  LOG_TYPE["CLICK"] = "2";
  /** 时长 */

  LOG_TYPE["DURATION"] = "8";
})(LOG_TYPE || (LOG_TYPE = {}));

var img = "data:image/png;base64,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";

/**
 * Tts UI控件
 */

var TtsPlayerUI = function () {
  function TtsPlayerUI(options, eventEmiitter) {
    this._el = document.querySelector(options.rootSelector);
    this.top = options.top;
    this.right = options.right;
    this.bottom = options.bottom;
    this.left = options.left;
    this._smallRight = options.smallRight;
    this._enableSmallPosition = options.enableSmallPosition;
    this._maxWidth = options.maxWidth || '100%';
    this._watchSmallWidth = options.smallWidth;
    this.duration = 0;
    this.image = img;
    this.title = '';
    this.volume = 1;
    this._imageEl = null;
    this._eventEmitter = eventEmiitter;
    this.prefixClass = 'pcTts';
    this._isPlaying = false;
    this._disableNext = true;
    this._showingVoiceColumn = false;
    this._renderedVoices = false;
    this.isRendered = false;
    this.isRendering = false;
    this._preVolume = this.volume;
    this._pointHeight = 8;

    if (!this._el) {
      throw new Error('Tts Player UI init fail!');
    }
  } // 修改位置


  TtsPlayerUI.prototype.editPosition = function (position) {
    if (!this._playerContainerEl) {
      return;
    }

    this.left = position.left || this.left;
    this.top = position.top || this.top;
    this.bottom = position.bottom || this.bottom;
    this.right = position.right || this.right;
    this._playerContainerEl.style.left = this.left;
    this._playerContainerEl.style.top = this.top;
    this._playerContainerEl.style.right = this.right;
    this._playerContainerEl.style.bottom = this.bottom;
  };

  TtsPlayerUI.prototype.hide = function () {
    this._changeShowingChooseDialog(false);

    this._closeVoiceColumn();

    this._el.style.display = 'none';
  };

  TtsPlayerUI.prototype.show = function () {
    if (this._el.style.display === 'none') {
      this._el.style.display = '';

      this._eventEmitter.emit(PlayerUIEvents.SHOW_PLAYER);
    }
  }; // 监听resize变更播放器尺寸


  TtsPlayerUI.prototype._watchResize = function () {
    var _this = this;

    window.addEventListener('resize', function () {
      _this.judgeSmallWidth();
    });
  }; // 判断播放器尺寸是否需要变更，需要则进行变更操作


  TtsPlayerUI.prototype.judgeSmallWidth = function () {
    var smallClass = this.getStyle('Small');

    if (window.innerWidth < this._watchSmallWidth) {
      if (this._enableSmallPosition) {
        this._playerContainerEl.style.right = this._smallRight;
      }

      this._playerContainerEl.classList.toggle(smallClass, true);
    } else {
      this._playerContainerEl.style.right = this.right;

      this._playerContainerEl.classList.toggle(smallClass, false);
    }
  }; // className的通用获取函数


  TtsPlayerUI.prototype.getStyle = function (str) {
    var className = "" + this.prefixClass + str;
    return styles[className];
  }; // 渲染播放器，并初始化事件


  TtsPlayerUI.prototype.render = function () {
    var _this = this;

    if (this.isRendered || this.isRendering) {
      return;
    }

    this.isRendering = true;
    var getStyle = this.getStyle.bind(this); // 绕过安全检查

    var str = 'innerHTML';
    this._el[str] = "\n            <div class=\"" + getStyle('FixContainer') + "\" style=\"max-width: " + this._maxWidth + ";\">\n                <div class=\"" + getStyle('Container') + "\"\n                    style=\"" + this._getContainerOptionStyle() + "\"\n                >\n                <div class=\"" + getStyle('Info') + "\">\n                    <div class=\"" + getStyle('ImageContainer') + "\">\n                        <div class=\"" + getStyle('ImageWrapper') + "\">\n                            <img src=\"" + this.image + "\" class=\"" + getStyle('Image') + "\"/>\n                        </div>\n                        <div class=\"" + getStyle('PlayingAni') + "\">\n                        </div>\n                        <div class=\"" + getStyle('LoadingAni') + "\"></div>\n                    </div>\n                    <div class=\"" + getStyle('Title') + " " + getStyle('TitleDefault') + "\">\n                        " + this.title + "\n                    </div>\n                </div>\n                <div class=\"" + getStyle('VoiceChooseContainer') + "\">\n                    <div class=\"" + getStyle('VoiceChooseNotice') + "\">\n                        <div class=\"" + getStyle('VoiceChooseTitle') + "\">\u9009\u62E9\u6717\u8BFB\u97F3\u8272</div>\n                        <div class=\"" + getStyle('VoiceChooseTips') + "\">\u652F\u6301\u591A\u9009\uFF0C\u4EA4\u66FF\u6717\u8BFB</div>\n                    </div>\n                    <div class=\"" + getStyle('VoiceChooseLeftIcon') + " " + getStyle('VoiceChooseIcon') + "\"></div>\n                    <div class=\"" + getStyle('VoiceChooseRightIcon') + " " + getStyle('VoiceChooseIcon') + "\"></div>\n                    <div class=\"" + getStyle('VoicesContainer') + "\">\n                    </div>\n                </div>\n                <div class=\"" + getStyle('Tools') + "\">\n                    <a class=\"" + getStyle('PlayIcon') + " " + getStyle('Icon') + " " + getStyle('EnableIcon') + "\" title=\"\u64AD\u653E/\u6682\u505C\"></a>\n                    <a class=\"" + getStyle('NextIcon') + " " + getStyle('Icon') + "\" title=\"\u4E0B\u4E00\u9996\"></a>\n                    <div class=\"" + getStyle('ProgressContainer') + "\">\n                        <div class=\"" + getStyle('CurrentTimeText') + "\">00:00</div>\n                        <div class=\"" + getStyle('ProgressBarContainer') + "\">\n                            <div class=\"" + getStyle('ProgressBarInner') + "\"></div>\n                        </div>\n                        <div class=\"" + getStyle('EndTimeText') + "\">00:00</div>\n                    </div>\n                    <a class=\"" + getStyle('VoiceChangeIcon') + " " + getStyle('EnableIcon') + " " + getStyle('Icon') + "\" title=\"\u97F3\u8272\u8C03\u6574\"></a>\n                    <div class=\"" + getStyle('VoiceColumnContainer') + "\">\n                        <a class=\"" + getStyle('VoiceColumnIcon') + " " + getStyle('EnableIcon') + " " + getStyle('Icon') + "\" title=\"\u97F3\u91CF\u8C03\u6574\"></a>\n                        <div class=\"" + getStyle('VoiceColumn') + "\">\n                            <div class=\"" + getStyle('VoiceBar') + "\">\n                                <div class=\"" + getStyle('VoicePoint') + "\" style=\"width: " + this._pointHeight + "px; height: " + this._pointHeight + "px;\"></div>\n                                <div class=\"" + getStyle('VoiceActiveBar') + "\"></div>\n                            </div>\n                            <a class=\"" + getStyle('VoiceSubIcon') + " " + getStyle('EnableIcon') + " " + getStyle('Icon') + "\" title=\"\u9759\u97F3\"></a>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"" + getStyle('Front') + "\"></div>\n                <div class=\"" + getStyle('BackgroundContainer') + "\">\n                    <div class=\"" + getStyle('Background') + "\"></div>\n                </div>\n                <a class=\"" + getStyle('CloseBtn') + " " + getStyle('EnableIcon') + " " + getStyle('Icon') + "}\" title=\"\u5173\u95ED\"></a>\n            </div>\n            </div>";
    nextTick().then(function () {
      _this._eventsInit();

      _this._renderVoices();

      _this.judgeSmallWidth();

      _this.isRendered = true;

      _this._eventEmitter.emit(PlayerUIEvents.SHOW_PLAYER);
    });
  }; // 初始化音色面板


  TtsPlayerUI.prototype.initVoiceList = function (voiceList) {
    this._voiceList = voiceList;
    this._isInitVoiceList = true;

    if (this._renderedVoices) {
      this._updateVoices();
    }
  }; // 渲染音色item列表


  TtsPlayerUI.prototype._renderVoices = function () {
    var _this = this;

    var voiceItems = this._voiceList.map(function (voiceItem) {
      return _this._renderVoiceItem(voiceItem);
    }); // 绕过安全检查


    var str = 'innerHTML';
    this._voicesEl[str] = voiceItems.join('');
    this._renderedVoices = true;
  }; // 更新音色item的选中状态


  TtsPlayerUI.prototype._updateVoices = function () {
    var _this = this;

    this._voiceList.forEach(function (voiceItem) {
      var itemEl = _this._voicesEl.querySelector("div[data-onlineid='" + voiceItem.onlineId + "']");

      itemEl.classList.toggle(_this.getStyle('VoiceItemActive'), voiceItem.isSelected);
    });
  }; // 渲染音色item


  TtsPlayerUI.prototype._renderVoiceItem = function (voiceItem) {
    var getStyle = this.getStyle.bind(this);
    var itemClass = [getStyle('VoiceItem'), voiceItem.isSelected ? getStyle('VoiceItemActive') : ''].join(' ');
    return "<div class=\"" + itemClass + "\" data-onlineid=\"" + voiceItem.onlineId + "\">\n            <img class=\"" + getStyle('VoiceItemImage') + "\" src=\"" + voiceItem.coverImg + "\" alt=\"\">\n            <div class=\"" + getStyle('VoiceItemHoverBorder') + "\"></div>\n            <div class=\"" + getStyle('VoiceChecked') + "\"></div>\n            <div class=\"" + getStyle('VoiceItemTitle') + "\">" + voiceItem.displayName + "</div>\n        </div>";
  }; // 绑定各种元素，绑定各种事件


  TtsPlayerUI.prototype._eventsInit = function () {
    // 绑定元素
    this._bindElements(); // 绑定播放器事件


    this._bindPlayerEvents(); // 绑定元素点击等事件


    this._bindDomEvents();
  }; // 绑定各个元素


  TtsPlayerUI.prototype._bindElements = function () {
    var getStyle = this.getStyle.bind(this); // container

    this._playerContainerEl = this._el.querySelector("." + getStyle('Container')); // 封面图

    this._imageEl = this._el.querySelector("." + getStyle('Image')); // 标题

    this._titleEl = this._el.querySelector("." + getStyle('Title')); // 背景

    this._backgroundEl = this._el.querySelector("." + getStyle('Background')); // icons

    this._playIconEl = this._el.querySelector("." + getStyle('PlayIcon'));
    this._nextIconEl = this._el.querySelector("." + getStyle('NextIcon'));
    this._voiceChangeIconEl = this._el.querySelector("." + getStyle('VoiceChangeIcon'));
    this._voiceColumnIconEl = this._el.querySelector("." + getStyle('VoiceColumnIcon'));
    this._voiceMuteIconEl = this._el.querySelector("." + getStyle('VoiceSubIcon'));
    this._closeIconEl = this._el.querySelector("." + getStyle('CloseBtn'));
    this._curTimeEl = this._el.querySelector("." + getStyle('CurrentTimeText'));
    this._endTimeEl = this._el.querySelector("." + getStyle('EndTimeText')); // 音量面板

    this._voiceColumnPointEl = this._el.querySelector("." + getStyle('VoicePoint'));
    this._voiceActiveBarEl = this._el.querySelector("." + getStyle('VoiceActiveBar'));
    this._voiceBar = this._el.querySelector("." + getStyle('VoiceBar'));
    this._voiceColumn = this._el.querySelector("." + getStyle('VoiceColumn')); // 进度条

    this._progressBarInnerEl = this._el.querySelector("." + getStyle('ProgressBarInner'));
    this._progressContainerEl = this._el.querySelector("." + getStyle('ProgressBarContainer')); // 音色选择

    this._voiceChooseDialogEl = this._el.querySelector("." + getStyle('VoiceChooseContainer'));
    this._voiceChooseLeftIcon = this._el.querySelector("." + getStyle('VoiceChooseLeftIcon'));
    this._voiceChooseRightIcon = this._el.querySelector("." + getStyle('VoiceChooseRightIcon'));
    this._voicesEl = this._el.querySelector("." + getStyle('VoicesContainer'));
  }; // 更新资源展示信息


  TtsPlayerUI.prototype._changeResourceStyle = function (playItem) {
    // 更新图片信息
    this.image = playItem.image || img;
    this._imageEl.src = this.image;

    this._setImageStyle(); // title信息


    this._titleEl.innerText = playItem.title; // title加载态

    this._titleEl.classList.toggle(this.getStyle('TitleDefault'), !playItem.title); // 开始、结束时间信息


    this._endTimeEl.innerText = formatTime(+playItem.duration);
    this._curTimeEl.innerText = formatTime(0);
    this.duration = +playItem.duration; // 重置进度条

    this._progressBarInnerEl.style.width = '0';
  }; // 绑定播放器内置事件


  TtsPlayerUI.prototype._bindPlayerEvents = function () {
    var _this = this; // 开始播放事件


    this._eventEmitter.on(CoreEvents.START_PLAY, function () {
      // 更新播放状态
      _this._changePlayState(true);

      _this._changeLoadingState(false);
    });

    this._eventEmitter.on(CoreEvents.LOAD_SOURCE_COMPLETE, function (_a) {
      var playItem = _a.playItem; // 资源信息加载完毕

      _this._changeResourceStyle(playItem);
    });

    this._eventEmitter.on(CoreEvents.LOAD_SOURCE_START, function () {
      _this.show();

      _this._changeLoadingState(true);

      _this._changePlayState(false);

      _this._changeResourceStyle({
        image: '',
        duration: '',
        title: '',
        titleList: [],
        contentList: [],
        id: ''
      });
    }); // 播放结束事件


    this._eventEmitter.on(CoreEvents.PLAY_END, function (playItem) {
      // 更新播放状态
      _this._changePlayState(false);
    });

    this._eventEmitter.on(CoreEvents.UPDATE_DURATION, function (duration) {
      var ratio = duration / _this.duration;
      ratio = ratio > 1 ? 1 : ratio; // 如果duration为0则ratio强制为0

      if (_this.duration === 0) {
        ratio = 0;
      }

      _this._curTimeEl.innerText = formatTime(ratio >= 1 ? _this.duration : duration);
      _this._progressBarInnerEl.style.width = ratio * 100 + "%";
    });

    this._eventEmitter.on(CoreEvents.DISABLE_NEXT, function () {
      _this._disableNext = true;

      _this._nextIconEl.classList.toggle(_this.getStyle('EnableIcon'), false);

      _this._nextIconEl.classList.toggle(_this.getStyle('DisableIcon'), true);
    });

    this._eventEmitter.on(CoreEvents.ENABLE_NEXT, function () {
      _this._disableNext = false;

      _this._nextIconEl.classList.toggle(_this.getStyle('EnableIcon'), true);

      _this._nextIconEl.classList.toggle(_this.getStyle('DisableIcon'), false);
    });

    this._eventEmitter.on(CoreEvents.PLAY, function () {
      _this._changePlayState(true);
    });

    this._eventEmitter.on(CoreEvents.PAUSE, function () {
      _this._changePlayState(false);
    });
  }; // 绑定dom事件


  TtsPlayerUI.prototype._bindDomEvents = function () {
    var _this = this;

    this._titleEl.addEventListener('click', function (e) {
      stopEventPop(e);

      _this._eventEmitter.emit(PlayerUIEvents.CLICK_TITLE);
    });

    this._voicesEl.addEventListener('click', function (e) {
      stopEventPop(e);
      var target = e.target;

      var voiceItemClassName = _this.getStyle('VoiceItem');

      if (isParentHasClass(target, voiceItemClassName)) {
        var voiceItemEl = findParent(target, voiceItemClassName);
        var onlineId = voiceItemEl.dataset.onlineid;
        var selectIndex = 0;

        for (var i = 0; i < _this._voiceList.length; i++) {
          var voiceItem = _this._voiceList[i];

          if (voiceItem.onlineId + '' === onlineId) {
            selectIndex = i;
            break;
          }
        }

        _this._voiceList[selectIndex].isSelected = !_this._voiceList[selectIndex].isSelected;

        var selectedItems = _this._voiceList.filter(function (voiceItem) {
          return voiceItem.isSelected;
        });

        if (selectedItems.length === 0) {
          _this._voiceList[selectIndex].isSelected = true;
        } else {
          _this._eventEmitter.emit(PlayerUIEvents.VOICE_CHOOSE, _this._voiceList[selectIndex]);
        }
      }
    });

    this._voiceMuteIconEl.addEventListener('click', function (e) {
      stopEventPop(e);

      _this._changeVolumeStyle(_this.volume > 0 ? 0 : _this._preVolume);
    });

    this._voiceChangeIconEl.addEventListener('click', function (e) {
      stopEventPop(e);

      _this._changeShowingChooseDialog(!_this._showingVoiceChooseDialog);

      _this._closeVoiceColumn();

      _this._eventEmitter.emit(PlayerUIEvents.VOICE_CHANGE_CLICK);
    });

    this._voiceChooseLeftIcon.addEventListener('click', function (e) {
      stopEventPop(e);

      _this._voicesEl.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    });

    this._voiceChooseRightIcon.addEventListener('click', function (e) {
      stopEventPop(e);

      _this._voicesEl.scrollTo({
        left: 1000,
        behavior: 'smooth'
      });
    });

    this._playIconEl.addEventListener('click', function (e) {
      stopEventPop(e);

      if (_this._isPlaying) {
        _this._eventEmitter.emit(PlayerUIEvents.PAUSE_CLICK);
      } else {
        _this._eventEmitter.emit(PlayerUIEvents.CONTINUE_CLICK);
      }
    });

    this._nextIconEl.addEventListener('click', function (e) {
      stopEventPop(e);

      if (_this._disableNext) {
        return;
      }

      _this._eventEmitter.emit(PlayerUIEvents.NEXT_CLICK);
    });

    this._voiceColumnIconEl.addEventListener('click', function (e) {
      stopEventPop(e);

      if (_this._showingVoiceColumn) {
        _this._closeVoiceColumn();
      } else {
        _this._showVoiceColumn();
      }

      _this._changeShowingChooseDialog(false);

      _this._eventEmitter.emit(PlayerUIEvents.VOICE_COLUMN_CLICK);
    });

    this._closeIconEl.addEventListener('click', function (e) {
      stopEventPop(e);

      _this._eventEmitter.emit(PlayerUIEvents.CLOSE_CLICK);
    });

    this._voiceBar.addEventListener('click', function (e) {
      stopEventPop(e);

      if (!isParentHasClass(e.target, _this.getStyle('VoicePoint'))) {
        _this._calVolumeChange(e.y);
      }
    });

    this._voiceColumnPointEl.addEventListener('mousedown', function (e) {
      stopEventPop(e);
      _this._voiceColumnTouching = true;
    });

    document.body.parentElement.addEventListener('mousemove', function (e) {
      if (!_this._voiceColumnTouching) {
        return;
      }

      _this._calVolumeChange(e.y);
    });
    document.body.parentElement.addEventListener('mouseup', function (e) {
      _this._voiceColumnTouching = false;
    });

    this._imageEl.addEventListener('load', function (e) {
      stopEventPop(e);

      _this._setImageStyle();
    }); // 开始监听页面宽度变更的尺寸


    this._watchResize();
  };

  TtsPlayerUI.prototype._calVolumeChange = function (targetY) {
    var barRect = this._voiceBar.getBoundingClientRect();

    var offset = barRect.bottom - targetY;

    if (offset <= 0) {
      offset = 0;
    } else if (offset > barRect.height - this._pointHeight) {
      offset = barRect.height - this._pointHeight;
    }

    this._voiceColumnPointEl.style.bottom = offset + "px";
    this._voiceActiveBarEl.style.height = offset + this._pointHeight + "px";
    var volume = offset / (barRect.height - this._pointHeight);
    this.volume = volume;

    this._changeMuteState(this.volume === 0);

    this._eventEmitter.emit(PlayerUIEvents.VOLUME_CHANGE, volume);
  };

  TtsPlayerUI.prototype._changeVolumeStyle = function (volume) {
    var barRect = this._voiceBar.getBoundingClientRect();

    var offset = (barRect.height - this._pointHeight) * volume;
    this._voiceColumnPointEl.style.bottom = offset + "px";
    this._voiceActiveBarEl.style.height = offset + this._pointHeight + "px";
    this._preVolume = this.volume;
    this.volume = volume;

    this._changeMuteState(this.volume === 0);

    this._eventEmitter.emit(PlayerUIEvents.VOLUME_CHANGE, volume);
  };

  TtsPlayerUI.prototype._changeMuteState = function (isMute) {
    this._playerContainerEl.classList.toggle(this.getStyle('Muted'), isMute);
  };

  TtsPlayerUI.prototype._changeLoadingState = function (isLoading) {
    this._isLoading = isLoading;

    this._playerContainerEl.classList.toggle(this.getStyle('Loading'), isLoading);
  };

  TtsPlayerUI.prototype._changePlayState = function (isPlaying) {
    this._playIconEl.classList.toggle(this.getStyle("ContinueIcon"), !isPlaying);

    this._playerContainerEl.classList.toggle(this.getStyle('Playing'), isPlaying);

    this._isPlaying = isPlaying;
  };

  TtsPlayerUI.prototype._changeShowingChooseDialog = function (isShow) {
    if (!this._voiceChooseDialogEl || !this._playerContainerEl || !this._voiceChangeIconEl) {
      return;
    }

    this._showingVoiceChooseDialog = isShow;
    this._voiceChooseDialogEl.style.display = isShow ? 'flex' : 'none';

    this._playerContainerEl.classList.toggle(this.getStyle('ShowingChoose'), this._showingVoiceChooseDialog);

    this._voiceChangeIconEl.classList.toggle(this.getStyle('ActiveIcon'), this._showingVoiceChooseDialog);
  };

  TtsPlayerUI.prototype._showVoiceColumn = function () {
    var _this = this;

    if (this._voiceColumn.style.display === 'block') {
      return;
    }

    this._voiceColumnIconEl.classList.toggle(this.getStyle('ActiveIcon'), true);

    this._voiceColumn.style.display = 'block';
    this._showingVoiceColumn = true;
    nextTick().then(function () {
      var barRect = _this._voiceBar.getBoundingClientRect();

      var offset = barRect.height * _this.volume;

      if (offset >= barRect.height - _this._pointHeight) {
        offset = barRect.height - _this._pointHeight;
      }

      _this._voiceColumnPointEl.style.bottom = offset + "px";
      _this._voiceActiveBarEl.style.height = barRect.height * _this.volume + "px";
    });

    var bindCloseEvent = function bindCloseEvent(e) {
      var target = e.target;

      if (_this._voiceColumnTouching) {
        return;
      }

      if (!isParentHasClass(target, _this.getStyle('VoiceColumn'))) {
        _this._closeVoiceColumn();

        document.body.parentElement.removeEventListener('click', bindCloseEvent);
      }
    };

    nextTick().then(function () {
      document.body.parentElement.addEventListener('click', bindCloseEvent);
    });
  };

  TtsPlayerUI.prototype._closeVoiceColumn = function () {
    if (!this._voiceColumnIconEl || !this._voiceColumn) {
      return;
    }

    this._showingVoiceColumn = false;
    this._voiceColumn.style.display = 'none';

    this._voiceColumnIconEl.classList.remove(this.getStyle('ActiveIcon'));
  };

  TtsPlayerUI.prototype._setImageStyle = function () {
    var width = this._imageEl.naturalWidth;
    var height = this._imageEl.naturalHeight;
    var ratio = width / height;
    var resultWidthStyle = '';
    var resultHeightStyle = '';

    if (ratio > 1) {
      resultWidthStyle = 'auto';
      resultHeightStyle = '100%';
    } else {
      resultWidthStyle = '100%';
      resultHeightStyle = 'auto';
    }

    this._imageEl.style.width = resultWidthStyle;
    this._imageEl.style.height = resultHeightStyle;
    this._backgroundEl.style.backgroundImage = "url(" + this.image + ")";
  };

  TtsPlayerUI.prototype._getContainerOptionStyle = function () {
    return getStyleString({
      top: this.top,
      right: this.right,
      bottom: this.bottom,
      left: this.left
    });
  };

  return TtsPlayerUI;
}();

var toObject$3 = toObject$6;
var toAbsoluteIndex$1 = toAbsoluteIndex$3;
var toLength$1 = toLength$6;

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject$3(this);
  var length = toLength$1(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex$1(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex$1(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var wellKnownSymbol$3 = wellKnownSymbol$j;
var create$1 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$3('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $$4 = _export;
var fill = arrayFill;
var addToUnscopables$2 = addToUnscopables$3;

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$$4({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('fill');

var fails$2 = fails$h;

var correctPrototypeGetter = !fails$2(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$1 = has$a;
var toObject$2 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject$2(O);
  if (has$1(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var fails$1 = fails$h;
var getPrototypeOf$1 = objectGetPrototypeOf;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;
var has = has$a;
var wellKnownSymbol$2 = wellKnownSymbol$j;

var ITERATOR$2 = wellKnownSymbol$2('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$1(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!has(IteratorPrototype$2, ITERATOR$2)) {
  createNonEnumerableProperty$2(IteratorPrototype$2, ITERATOR$2, returnThis$2);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$1 = setToStringTag$3;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor$1(1, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$3 = _export;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var redefine = redefine$8.exports;
var wellKnownSymbol$1 = wellKnownSymbol$j;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$1('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$2 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
          createNonEnumerableProperty$1(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty$1(IterablePrototype, ITERATOR$1, defaultIterator);
  }
  Iterators$1[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$3({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$3;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineIterator$1 = defineIterator$2;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

var charAt = stringMultibyte.charAt;
var toString = toString$5;
var InternalStateModule = internalState;
var defineIterator = defineIterator$2;

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var global$1 = global$o;
var DOMIterables = domIterables;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$9;
var wellKnownSymbol = wellKnownSymbol$j;

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}

var $$2 = _export;
var $find = arrayIteration.find;
var addToUnscopables = addToUnscopables$3;

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$$2({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var jsonpIndex = 0;
function jsonp(url, params, timeout) {
  if (params === void 0) {
    params = {};
  }

  if (timeout === void 0) {
    timeout = 5000;
  }

  return new Promise(function (resolve, reject) {
    var editUrl = function editUrl(url) {
      return url + (url.indexOf('?') >= 0 ? '&' : '?');
    };

    url = editUrl(url);
    var jsonpName = "JSONP_" + jsonpIndex++;

    window[jsonpName] = function (res) {
      resolve(res);
      clearTimeout(timeoutIndex);
      delete window[jsonpName];
      removeChild(document.body, scriptEl);
    };

    var paramsString = paramsToString(__assign(__assign({}, params), {
      callback: jsonpName
    }));
    var timeoutIndex = window.setTimeout(function () {
      removeChild(document.body, scriptEl);
      reject({
        errorType: ErrorType.NET_WORK_ERROR,
        data: {
          url: url
        }
      });
    }, timeout);
    url += paramsString;
    var scriptEl = document.createElement('script');
    scriptEl.src = url;
    document.body.appendChild(scriptEl);
  });
}

/**
 * @private
 * @module debug
 * @category utils
 * @author leizhihao@baidu.com
 */
/**
 * debug日志
 * @param args
 */


var debugLog = function debugLog() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
};
/**
 * debug错误日志
 * @param args
 */

var debugError = function debugError() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
};

/**
 * @private
 * @module const
 * @category types
 * @author leizhihao@baidu.com
 */
var TTS_PLAYER_COOKIE = 'tts_playerid';
var SAFARI_FIX_AUDIO_SRC = 'https://mbdp02.bdstatic.com/static/mp3/nothing.mp3';

/**
 * @private
 * @module browser
 * @category utils
 * @author leizhihao@baidu.com
 */

/**
 * 判断是否是IE
 * @private
 */
var isIE = function isIE() {
  var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object

  var msie = ua.indexOf('MSIE '); // IE 10 or older

  var trident = ua.indexOf('Trident/'); //IE 11

  return msie > 0 || trident > 0;
};
/**
 * 判断是否是Ipad
 * @private
 */

var isIpad = function isIpad() {
  return !!window.navigator.userAgent.match(/(iPad)/)
  /* iOS pre 13 */
  || !!(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  /* iPad OS 13 */
  ;
};
/**
 * 判断是否是safari
 * @private
 */

var isSafari = function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

/**
 * @private
 * @description 播放器核心，控制播放、音色获取、切换等主要功能
 */

var TtsPlayerCore = function () {
  /**
   * @param options {TtsPlayerCoreOptions} 初始化选项
   * @param eventEmitter {EventEmitter} 事件派发器
   */
  function TtsPlayerCore(options, eventEmitter) {
    this.isPaused = true;
    this.curPlayItem = null;
    this.curAudioIndex = [0, 0];
    this._contentCacheIndex = [0, 0];
    this.curVoiceItem = null;
    this._loadOvertime = options.loadOvertime || 5000;
    this._eventEmitter = eventEmitter;
    this._maxCacheNum = 4;
    this.volume = 1;
    this._sourceItems = [];
    this._getVoiceListApi = options.getVoiceListApi || 'https://mbd.baidu.com/newspage/api/getpcvoicelist';
    this._editVoiceListApi = options.editVoiceListApi || 'https://mbd.baidu.com/newspage/api/updateuservoice';
    this._userVoiceList = options.voiceList || [];
    this._overtimeTimeout = null;
    this._playItemPromise = null;
    this._isPlayEnd = false;
    this._isPlaying = false;
    this._isCaching = false;
    this._playCount = 0;
    this._playDuration = 0;
    this._editFunc = options.editFunc;
    this._isFirstPlay = true;
    this._audioLoadOvertime = options.audioLoadOvertime || 15000;

    if (this._userVoiceList.length > 0) {
      this._initVoiceList(options.voiceList || []);
    }

    this._init();
  }
  /**
   * 修改用户音色的后端接口调用
   * @param voiceIds
   */


  TtsPlayerCore.prototype._editVoices = function (voiceIds) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      jsonp(_this._editVoiceListApi, {
        voiceIds: voiceIds
      }).then(function (res) {
        if (+res.errno === 0) {
          resolve();
        } else {
          debugError(res);
          reject('update voices failed');
        }
      });
    });
  };
  /**
   * 是否支持播放类型(暂不支持iPad及IE)
   * @public
   */


  TtsPlayerCore.isSupport = function () {
    return !(isIE() || isIpad());
  };
  /**
   * safari第一次播放失败的BUG修复
   * 原因分析： https://developer.apple.com/forums/thread/94522
   * 解决方法：提前放一个没内容的audio放进html中，当触发play时(因为play需要发接口拿数据)，先让这个audio播放一下，就不会报错了(不知道为什么这样就可以)
   * @private
   */


  TtsPlayerCore.prototype._safariInit = function () {
    if (!isSafari()) {
      return;
    }

    var audio = document.createElement('audio');
    audio.muted = true;
    audio.autoplay = true;
    audio.src = SAFARI_FIX_AUDIO_SRC;
    this._safariAudio = audio;
    document.body.appendChild(this._safariAudio);
  };
  /**
   * safari需要在第一次播放时同步执行一个audio的play才能播放
   * @private
   */


  TtsPlayerCore.prototype._safariPlay = function () {
    if (!isSafari()) {
      return;
    }

    if (!this._isFirstPlay) {
      return;
    }

    try {
      this._safariAudio.play();

      removeChild(this._safariAudio.parentElement, this._safariAudio);
      this._isFirstPlay = false;
    } catch (e) {
      debugError(e);
    }
  };
  /**
   * 获取现在正在播放的资源的位置
   */


  TtsPlayerCore.prototype.getCurIndex = function () {
    if (!this.curPlayItem) {
      return -2;
    }

    var curid = this.curPlayItem.id;

    for (var i = 0; i < this._sourceItems.length; i++) {
      if (this._sourceItems[i].id === curid) {
        return i;
      }
    }

    return -2;
  };
  /**
   * 是否有包含下一首
   */


  TtsPlayerCore.prototype.hasNext = function () {
    if (!this.curPlayItem) {
      return false;
    }

    return !!this._sourceItems[this.getCurIndex() + 1];
  };
  /**
   * 播放下一首
   */


  TtsPlayerCore.prototype.playNext = function () {
    debugLog('开始播放下一首, 是否含有下一首:', this.hasNext());

    if (this.hasNext()) {
      this.play(this._sourceItems[this.getCurIndex() + 1].id);
      this._isPlayEnd = false;
    } else {
      this._isPlayEnd = true;
    }
  };
  /**
   * 修改音量
   * @param val 需要调整到的音量
   */


  TtsPlayerCore.prototype.changeVolume = function (val) {
    if (this.curAudioEl) {
      this.curAudioEl.volume = val;
    }
  };
  /** 清除数据 */


  TtsPlayerCore.prototype._clearData = function () {
    this._pauseAudioEl();

    this._cancelCalDuration();
  };
  /**
   * 根据id与音色，请求api获取资源详细信息
   * @param id 需要获取的资源id
   * @param voiceItem 资源对应的音色
   */


  TtsPlayerCore.prototype._getPlayItem = function (id, voiceItem) {
    debugLog('开始获取音频资源', 'id: ', id, '音色信息', voiceItem);

    for (var i = 0; i < this._sourceItems.length; i++) {
      if (this._sourceItems[i].id === id) {
        return this.loadSource(this._sourceItems[i], voiceItem).then(function (playItem) {
          debugLog('获取资源信息成功', playItem);

          if (playItem) {
            return playItem;
          } else {
            return Promise.reject({
              errorType: ErrorType.LOAD_ERROR,
              data: {
                id: id
              }
            });
          }
        });
      }
    }

    return Promise.reject({
      errorType: ErrorType.LOAD_ERROR,
      data: {
        msg: 'id is not found!',
        id: id
      }
    });
  };
  /**
   * 播放指定id的资源
   * @param id 播放器id
   * @param voiceItem 音色信息
   * @param playParagraph 指定开始播放的段落
   */


  TtsPlayerCore.prototype.play = function (id, voiceItem, playParagraph) {
    var _this = this;

    if (this._isLoading) {
      return;
    }

    debugLog('开始播放id: ', id, '当前播放id: ', this._curPlayId, '当前播放状态:', this._isPlaying);

    if (id === this._curPlayId && this._isPlaying && !voiceItem) {
      debugLog('开始播放失败 - 正在播放当前id或者没有找到音色信息');
      return;
    }

    this._isLoading = true;

    if (id !== this._curPlayId) {
      this._eventEmitter.emit(CoreEvents.CHANGE_ID);
    }

    if (playParagraph === undefined) {
      playParagraph = 0;
    }

    this._pauseAudioEl();

    this._playCount++;
    var playCount = this._playCount;
    var lastPlayItem = this.curPlayItem;
    var contentPromise = null;
    var titleAudioEls = [];
    this._isPlayEnd = false;
    this._isPlaying = true;
    this._curPlayId = id; // 超时判断

    var isReject = false;

    if (this._overtimeTimeout !== null) {
      clearTimeout(this._overtimeTimeout);
    } // 播放整体条件准备超时设置(请求得到音频资源列表+请求得到标题音频+请求得到第一个正文音频)


    this._overtimeTimeout = window.setTimeout(function () {
      debugError('prepare failed', _this._loadOvertime);
      isReject = true;

      _this._pauseAudioEl();

      _this._emitError(ErrorType.NET_WORK_ERROR, {
        id: _this._curPlayId
      });

      _this._isLoading = false;
      _this._isPlaying = false;
    }, this._loadOvertime);

    this._safariPlay(); // 抛出正在加载的事件，用于UI增加加载态


    this._eventEmitter.emit(CoreEvents.LOAD_SOURCE_START); // 根据id获取对应的资源列表


    this._getPlayItem(id, voiceItem).then(function (playItem) {
      // 加载资源结束
      _this._eventEmitter.emit(CoreEvents.LOAD_SOURCE_COMPLETE, {
        playItem: playItem
      });

      debugLog('开始尝试播放', 'id: ', id, '资源信息：', playItem);

      if (playCount !== _this._playCount) {
        _this._isLoading = false;
        debugLog('curPlayItem changed, stop play 1');
        return;
      }

      _this._clearData();

      _this.curPlayItem = playItem;
      _this._audioCache = new Array(_this.curPlayItem.contentList.length + 1).fill(function (_) {
        return 0;
      }).map(function (_) {
        return [];
      }); // 先将标题全部缓存后再开始播放

      var promises = _this.curPlayItem.titleList.map(function (titleVoiceSrc) {
        return _this._loadAudio(titleVoiceSrc);
      });

      _this.curAudioIndex = [playParagraph, 0];
      _this._contentCacheIndex = [playParagraph - 1 < 0 ? 0 : playParagraph - 1, 0]; // 找到不为空的第一段段落文字

      while (!_this.curPlayItem.contentList[_this._contentCacheIndex[0]][0]) {
        _this._contentCacheIndex[0]++;
      } // 开始缓存第一段正文


      contentPromise = _this._cacheContent(); // 等待标题所有语音的请求返回

      return Promise.all(promises);
    }).then(function (audioEls) {
      debugLog('获取标题成功', id);
      titleAudioEls = audioEls; // 等待第一个正文的请求

      return contentPromise;
    }).then(function () {
      // 准备工作完毕，准备开始播放
      debugLog('第一段正文加载完毕', id);
      _this._isLoading = false;

      if (playParagraph === 0) {
        _this._playDuration = 0;
      }

      if (playParagraph === 0 && titleAudioEls.length === 0) {
        playParagraph = 1;
      }

      _this._audioCache[0] = titleAudioEls;
      _this.curAudioEl = _this._audioCache[playParagraph][0];
      _this._durationInterval = window.setInterval(function () {
        var count = _this._calDuration();

        if (count !== undefined) {
          _this._eventEmitter.emit(CoreEvents.UPDATE_DURATION, count);
        }
      }, 200);
      return nextTick();
    }).then(function () {
      _this._pauseAudioEl();

      if (isReject) {
        _this._isLoading = false;
        _this._isPlayEnd = false;
        _this._isPlaying = false;
        return;
      } else {
        clearTimeout(_this._overtimeTimeout);
      }

      _this._startPlay(playCount).then(function () {
        _this._eventEmitter.emit(CoreEvents.START_PLAY, {
          curPlayItem: _this.curPlayItem,
          lastPlayItem: lastPlayItem
        });

        _this._eventEmitter.emit(_this.hasNext() ? CoreEvents.ENABLE_NEXT : CoreEvents.DISABLE_NEXT);

        _this._eventEmitter.emit(CoreEvents.CHANGE_PARAGRAPH, playParagraph);
      }).catch(function (e) {
        debugError('play func failed', _this.curPlayItem);
      });
    }).catch(function (e) {
      debugError("play " + id + " failed :", e);
      _this._isLoading = false;
      _this._isPlayEnd = false;
      _this._isPlaying = false; // 如果已经报过超时错误则不再抛出错误

      if (isReject) {
        return;
      } // 清理掉超时处理的timeout，避免错误重复上报


      clearTimeout(_this._overtimeTimeout);

      if (e.errorType) {
        _this._emitError(e.errorType, __assign(__assign({}, e.data), {
          id: id
        }));
      } else {
        _this._emitError(ErrorType.UNKNOWN_ERROR, {
          error: e,
          id: id
        });
      }
    });
  };
  /**
   * 计算现在已播放时长
   */


  TtsPlayerCore.prototype._calDuration = function () {
    var _a = this.curAudioIndex,
        x = _a[0],
        y = _a[1];

    if (this._audioCache[x] && this._audioCache[x][y]) {
      var audioEl = this._audioCache[x][y];
      return Math.floor(this._playDuration + audioEl.currentTime);
    }
  };
  /**
   * 停止计算时长定时器
   */


  TtsPlayerCore.prototype._cancelCalDuration = function () {
    clearInterval(this._durationInterval);
  };
  /**
   * 缓存音频资源
   * @param x
   * @param y
   */


  TtsPlayerCore.prototype._cacheContent = function (x, y) {
    var _a;

    var _this = this;

    var id = this._curPlayId;
    var contentList = this.curPlayItem.contentList;

    if (x === undefined || y === undefined) {
      _a = this._contentCacheIndex, x = _a[0], y = _a[1];
    }

    debugLog('cacheContent:', [x + 1, y], 'playingItem: ', this.curAudioIndex, 'diff:', this._getCacheDiff());

    if (this._isCaching) {
      debugError('isCaching, quit');
      return;
    }

    var retryNum = 0;
    return new Promise(function (resolve, reject) {
      var load = function load() {
        if (contentList[x] && contentList[x][y]) {
          _this._isCaching = true;

          _this._loadAudio(contentList[x][y]).then(function (audioEl) {
            _this._isCaching = false;

            if (_this._curPlayId !== id) {
              debugError('load complete, but id is changed, src:', audioEl.src);
              return Promise.resolve();
            }

            _this._audioCache[x + 1][y] = audioEl;

            _this._cacheIndexNext();

            _this._cacheContent();

            resolve();
          }, function () {
            if (retryNum < 2) {
              debugError('audio load failed', 'retrying', x, y);
              retryNum++;
              load();
            } else {
              debugError('audio load failed', x, y);
              reject({
                errorType: ErrorType.LOAD_ERROR,
                id: _this._curPlayId
              });
              _this._isCaching = false;
            }
          });
        }
      };

      if (_this._getCacheDiff() <= _this._maxCacheNum) {
        if (_this._audioCache[x + 1] && _this._audioCache[x + 1].length === 0) {
          _this._audioCache[x + 1] = new Array(contentList[x].length);
        }

        load();
      }
    });
  };
  /**
   * 移动缓存坐标到下一个需要缓存的资源
   */


  TtsPlayerCore.prototype._cacheIndexNext = function () {
    var _a = this._contentCacheIndex,
        x = _a[0],
        y = _a[1]; // 如果当前缓存指针为空时，则自己是最后一个需要缓存的资源

    if (this._audioCache[x + 1] && !this._audioCache[x + 1][y]) {
      return;
    }

    if (this.curPlayItem.contentList[x] && y === this.curPlayItem.contentList[x].length - 1) {
      x++;

      while (this.curPlayItem.contentList[x] && this.curPlayItem.contentList[x].length === 0) {
        x++;
      }

      y = 0;
    } else {
      y++;
    }

    this._contentCacheIndex[0] = x;
    this._contentCacheIndex[1] = y;
  };
  /**
   * 暂停后的继续播放
   */


  TtsPlayerCore.prototype.continue = function () {
    // 如果无下一首，且已播完，则重播
    if (this._isPlayEnd) {
      this.play(this._curPlayId);
      return;
    } else {
      this._playAudioEl(this._playCount);
    }
  };
  /**
   * 暂停播放
   */


  TtsPlayerCore.prototype.pause = function () {
    this._pauseAudioEl(true);
  };
  /**
   * 获取指定坐标的音频Audio元素
   * @param x
   * @param y
   */


  TtsPlayerCore.prototype._getAudioItem = function (x, y) {
    if (!this._audioCache[x]) {
      return null;
    } else if (!this._audioCache[x][y]) {
      return null;
    } else {
      return this._audioCache[x][y];
    }
  };
  /** 获取当前播放的音频资源与已缓存资源的差值 */


  TtsPlayerCore.prototype._getCacheDiff = function () {
    var _a = this.curAudioIndex,
        x = _a[0],
        y = _a[1];
    var count = 0;

    for (var i = x; i < this.curPlayItem.contentList.length + 1; i++) {
      var list = i === 0 ? this.curPlayItem.titleList : this.curPlayItem.contentList[i - 1];
      var startJ = i === x ? y : 0;

      for (var j = startJ; j < list.length; j++) {
        if (this._audioCache[i] && this._audioCache[i][j]) {
          count++;
        }
      }
    }

    return count;
  };
  /**
   * 准备工作完毕后播放控制的核心函数
   * @param playCount
   */


  TtsPlayerCore.prototype._startPlay = function (playCount) {
    var _this = this;

    if (playCount === undefined) {
      playCount = this._playCount;
    }

    if (this._playCount !== playCount) {
      return;
    }

    this.changeVolume(this.volume);

    var playListener = function playListener(e) {
      _this._playDuration += _this.curAudioEl.duration; // y先+1

      _this.curAudioIndex[1]++; // x, y+1 存在，则播放

      if (_this._getAudioItem(_this.curAudioIndex[0], _this.curAudioIndex[1])) {
        _this.curAudioEl = _this._audioCache[_this.curAudioIndex[0]][_this.curAudioIndex[1]];

        _this._startPlay();

        _this._cacheContent();
      } else {
        // x + 1，直到找到有可播放的资源
        _this.curAudioIndex[1] = 0;
        _this.curAudioIndex[0]++;

        while (_this._audioCache[_this.curAudioIndex[0]] && _this._audioCache[_this.curAudioIndex[0]].length === 0) {
          _this.curAudioIndex[0]++;
        }

        if (_this._getAudioItem(_this.curAudioIndex[0], _this.curAudioIndex[1])) {
          _this._eventEmitter.emit(CoreEvents.CHANGE_PARAGRAPH, _this.curAudioIndex[0]);

          _this.curAudioEl = _this._audioCache[_this.curAudioIndex[0]][_this.curAudioIndex[1]];

          _this._startPlay();

          _this._cacheContent();
        } else {
          // 没找到则判断为结束
          debugLog('play end', _this.curPlayItem);

          _this._eventEmitter.emit(CoreEvents.PLAY_END, _this.curPlayItem);

          _this._eventEmitter.emit(CoreEvents.PAUSE, _this.curPlayItem);

          _this._isPlaying = false;

          _this.playNext();
        }
      }

      if (_this.curAudioEl) {
        _this.curAudioEl.removeEventListener('ended', playListener);
      }
    };

    if (this.curAudioEl) {
      this.curAudioEl.addEventListener('ended', playListener);
    }

    return this._playAudioEl(playCount).catch(function (e) {
      debugError('start play audio failed', e);
      return Promise.reject(e);
    });
  };
  /**
   * 加载音频url
   * @param src 音频资源url地址
   * @param retryNum 重试次数
   */


  TtsPlayerCore.prototype._loadAudio = function (src, retryNum) {
    var _this = this;

    if (retryNum === void 0) {
      retryNum = 3;
    }

    var loadAudioTimeout;
    var isTimeout = false;
    return new Promise(function (resolve, reject) {
      var load = function load() {
        var voiceEl = document.createElement('audio');
        voiceEl.src = src;
        voiceEl.load();
        voiceEl.muted = true;
        voiceEl.preload = 'auto'; // 音频超时处理

        loadAudioTimeout = window.setTimeout(function () {
          isTimeout = true;
          removeChild(document.body, voiceEl);
          retryNum--;

          if (retryNum <= 0) {
            debugError('audio load failed', voiceEl.src);
            reject({
              errorType: ErrorType.LOAD_ERROR,
              data: {
                src: voiceEl.src
              }
            });
          } else {
            debugLog('audio load timeout', 'retrying', 'retry last time', retryNum, 'src', voiceEl.src);
            load();
          }
        }, _this._audioLoadOvertime);
        voiceEl.addEventListener('canplaythrough', function () {
          // 如果已经超时，则不处理
          if (isTimeout) {
            return;
          }

          removeChild(document.body, voiceEl);
          clearTimeout(loadAudioTimeout);
          resolve(voiceEl);
        });
        document.body.appendChild(voiceEl);
      };

      load();
    });
  };
  /**
   * 后端请求音色信息
   */


  TtsPlayerCore.prototype.loadVoices = function () {
    var _this = this;

    if (this._userVoiceList.length > 0) {
      return Promise.resolve();
    }

    debugLog('开始获取音色信息', this._getVoiceListApi);
    return jsonp(this._getVoiceListApi).then(function (res) {
      if (res && +res.errno !== 0) {
        return Promise.reject({
          errorType: ErrorType.LOAD_ERROR,
          data: {}
        });
      }

      debugLog('获取音色信息成功', res.data.voiceList);
      var voiceList = res.data.voiceList.map(function (item) {
        return {
          displayName: item.display_name,
          onlineId: item.online_id,
          displayIndex: item.display_index,
          coverImg: item.cover_img,
          isSelected: !!+item.is_selected,
          speakerId: item.speaker_id
        };
      });

      _this._initVoiceList(voiceList);
    }).catch(function (e) {
      if (e.errorType) {
        _this._emitError(e.errorType, e.data);
      } else {
        _this._emitError(ErrorType.UNKNOWN_ERROR, {
          error: e
        });
      }

      return Promise.reject(e);
    });
  };

  TtsPlayerCore.prototype._emitError = function (errorType, data) {
    if (data === void 0) {
      data = {};
    }

    debugError("errorType: " + errorType, data);

    this._eventEmitter.emit(CoreEvents.ERROR, {
      errorType: errorType,
      data: data
    });
  };
  /**
   * 移动到下一个音色
   */


  TtsPlayerCore.prototype._changeToNextVoice = function () {
    var curVoiceIndex = this.curVoiceIndex;

    for (var i = 1; i <= this._userVoiceList.length; i++) {
      var voiceIndex = (curVoiceIndex + i) % this._userVoiceList.length;

      if (this._userVoiceList[voiceIndex].isSelected) {
        this.curVoiceIndex = voiceIndex;
        this.curVoiceItem = this._userVoiceList[voiceIndex];
        break;
      }
    }

    return this.curVoiceItem;
  };
  /**
   * 新增播放列表
   * @param sourceItems {Array<SourceItem>} 资源列表
   * @returns {void}
   */


  TtsPlayerCore.prototype.addItems = function (sourceItems) {
    var _this = this;

    sourceItems.forEach(function (sourceItem1) {
      var sourceItem = _this._sourceItems.find(function (sourceItem2) {
        return sourceItem1.id === sourceItem2.id;
      });

      if (!sourceItem) {
        _this._sourceItems.push(sourceItem1);

        _this._isPlayEnd = false;
      }
    });

    this._eventEmitter.emit(this.hasNext() ? CoreEvents.ENABLE_NEXT : CoreEvents.DISABLE_NEXT);
  };
  /**
   * 更新播放列表，原有的播放列表会被全部替换掉
   * @param sourceItems {Array<SourceItem>} 资源列表
   * @returns {void}
   */


  TtsPlayerCore.prototype.updateItems = function (sourceItems) {
    var _this = this;

    this._sourceItems = [];
    sourceItems.forEach(function (sourceItem1) {
      var sourceItem = _this._sourceItems.find(function (sourceItem2) {
        return sourceItem2.id === sourceItem1.id;
      });

      if (!sourceItem) {
        _this._sourceItems.push(sourceItem1);

        _this._isPlayEnd = false;
      }
    });

    this._eventEmitter.emit(this.hasNext() ? CoreEvents.ENABLE_NEXT : CoreEvents.DISABLE_NEXT);
  };
  /**
   * 请求资源信息
   * @param sourceItem 资源原始信息
   * @param voiceItem 音色信息
   */


  TtsPlayerCore.prototype.loadSource = function (sourceItem, voiceItem) {
    if (!voiceItem) {
      voiceItem = this._changeToNextVoice();
    }

    return jsonp(sourceItem.requestUrl, __assign(__assign({}, sourceItem.requestParams), {
      tone: voiceItem.onlineId
    })).then(function (res) {
      var data = res.data.length > 0 ? res.data[0] : res.data;

      if (res && +res.errno !== 0) {
        return Promise.reject({
          errorType: ErrorType.LOAD_ERROR,
          data: {
            sourceItem: sourceItem
          }
        });
      }

      if (data) {
        var playItem = {
          id: data.nid,
          titleList: data.titleList || [],
          contentList: data.contentList || [],
          title: data.title,
          image: data.image,
          duration: data.duration,
          logParams: sourceItem.logParams || {}
        };
        return playItem;
      } else {
        return null;
      }
    });
  };
  /**
   * 开始播放当前的音频元素
   * @param playCount 播放的数量，用于防止重复调用
   */


  TtsPlayerCore.prototype._playAudioEl = function (playCount) {
    var _this = this;

    debugLog('_playAudioEl()', this.curAudioEl);

    if (this._isLoading) {
      return Promise.resolve();
    }

    if (this._playCount !== playCount) {
      return Promise.resolve();
    }

    if (!this.curAudioEl) {
      this.isPaused = true;
      return Promise.resolve();
    }

    this.curAudioEl.muted = false;
    return new Promise(function (resolve, reject) {
      _this.curAudioEl.play().then(function (res) {
        _this.isPaused = false;

        _this._eventEmitter.emit(CoreEvents.PLAY, _this.curPlayItem);

        _this._writePlayingCookie();

        resolve();
      }).catch(function (e) {
        debugError('play error!');
        reject(e);
      });
    });
  };
  /**
   * 暂停当前播放的音频元素
   */


  TtsPlayerCore.prototype._pauseAudioEl = function (shouldEmitEvents) {
    if (shouldEmitEvents === void 0) {
      shouldEmitEvents = false;
    }

    if (!this.curAudioEl) {
      this.isPaused = true;
      return;
    }

    if (this.isPaused) {
      return;
    }

    this.curAudioEl.pause();
    this.isPaused = true;
    shouldEmitEvents && this._eventEmitter.emit(CoreEvents.PAUSE, this.curPlayItem);
  };
  /**
   * 生成播放器playerId
   */


  TtsPlayerCore.prototype._registerPlayerId = function () {
    this._playerId = Date.now().toString() + Math.floor(Math.random() * 1000).toString();
  };
  /**
   * 往cookie中写入tts player id
   */


  TtsPlayerCore.prototype._writePlayingCookie = function () {
    document.cookie = TTS_PLAYER_COOKIE + "=" + escape(this._playerId) + ";path=/;domain=baidu.com";
  };
  /**
   * 监听cookie中的tts player id，如果与当前播放器的player id不等，暂停自己
   */


  TtsPlayerCore.prototype._watchPlayingId = function () {
    var _this = this;

    setInterval(function () {
      var curPlayerId = getCookie(TTS_PLAYER_COOKIE);

      if (_this._playerId !== curPlayerId && !_this.isPaused) {
        _this._pauseAudioEl(true);
      }
    }, 300);
  };
  /**
   * 当开发者在初始化时直接传入音频列表时，直接使用这个音频列表初始化，不再使用getVoiceListApi请求音频资源
   * @param voiceList 音频列表
   */


  TtsPlayerCore.prototype._initVoiceList = function (voiceList) {
    this._userVoiceList = voiceList;

    for (var i = 0; i < voiceList.length; i++) {
      if (+voiceList[i].isSelected === 1) {
        this.curVoiceItem = voiceList[i];
        this.curVoiceIndex = i;
      }
    }

    this._eventEmitter.emit(CoreEvents.LOAD_VOICES, voiceList);
  };
  /**
   * 初始化播放器核心
   */


  TtsPlayerCore.prototype._init = function () {
    var _this = this;

    this._eventEmitter.on(PlayerUIEvents.VOLUME_CHANGE, function (val) {
      _this.changeVolume(val);

      _this.volume = val;
    });

    this._eventEmitter.on(PlayerUIEvents.CONTINUE_CLICK, function () {
      _this.continue();
    });

    this._eventEmitter.on(PlayerUIEvents.PAUSE_CLICK, function () {
      _this.pause();
    });

    this._eventEmitter.on(PlayerUIEvents.NEXT_CLICK, function () {
      _this.playNext();
    });

    this._eventEmitter.on(PlayerUIEvents.VOICE_CHOOSE, function (voiceItem) {
      var voiceIds = [];
      var isAdd = voiceItem.isSelected; // 如果该项是选中则证明这次是新增
      // 收集需要选中的voiceId，用于发给后端进行修改

      for (var i = 0; i < _this._userVoiceList.length; i++) {
        var subVoiceItem = _this._userVoiceList[i]; // 插入除了voiceItem之外，其他已经选中的id

        if (subVoiceItem.isSelected && subVoiceItem.onlineId !== voiceItem.onlineId) {
          voiceIds.push(subVoiceItem.onlineId);
        }
      } // 判断这次选中的voiceItem是否需要插入


      isAdd && voiceIds.push(voiceItem.onlineId);
      debugLog('更新后的音色列表：', voiceIds);

      var resolveFunc = function resolveFunc() {
        var selectedIndex = 0;

        _this._userVoiceList.forEach(function (voiceItem) {
          var isSelected = false;

          for (var i = 0; i < voiceIds.length; i++) {
            if (voiceItem.onlineId === voiceIds[i]) {
              selectedIndex = i;
              isSelected = true;
            }
          }

          voiceItem.isSelected = isSelected;
        });

        _this._eventEmitter.emit(CoreEvents.LOAD_VOICES, _this._userVoiceList);

        if ( // 如果新增则需要切换成新的音色给用户进行播放
        isAdd || // 如果是删除的是当前播放的音色，则需要切换到下一个音色进行播放
        voiceItem.onlineId === _this.curVoiceItem.onlineId) {
          if (isAdd) {
            _this.curVoiceIndex = selectedIndex;
            _this.curVoiceItem = voiceItem;
          } else {
            _this._changeToNextVoice();
          } // 音色切换完毕开始播放


          _this.play(_this.curPlayItem.id, _this.curVoiceItem, _this.curAudioIndex[0]);
        }
      }; // 更新操作是默认或者开发者自行设置


      if (_this._editFunc) {
        _this._editFunc(voiceIds, resolveFunc.bind(_this));
      } else {
        _this._editVoices(voiceIds).then(resolveFunc.bind(_this)).catch(function (e) {
          _this._emitError(ErrorType.UPDATE_VOICE_ERROR, {
            voiceIds: voiceIds
          });
        });
      }
    });

    this._registerPlayerId();

    this._watchPlayingId();

    this._safariInit();
  };

  return TtsPlayerCore;
}();

var toPropertyKey = toPropertyKey$3;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$4;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var $$1 = _export;
var toAbsoluteIndex = toAbsoluteIndex$3;
var toInteger = toInteger$4;
var toLength = toLength$6;
var toObject$1 = toObject$6;
var arraySpeciesCreate = arraySpeciesCreate$2;
var createProperty = createProperty$1;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$3;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$$1({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject$1(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

/**
 * @private
 * @module EventEmitter
 * @category classes
 * @author leizhihao@baidu.com
 */

/**
 * 事件派发器
 */
var EventEmitter = function () {
  function EventEmitter() {
    this._eventMap = {};
  }

  EventEmitter.prototype.checkEventNameExist = function (eventName) {
    return this._eventMap[eventName] !== undefined;
  };

  EventEmitter.prototype.checkCallbackExist = function (eventName, callback) {
    if (this.checkEventNameExist(eventName)) {
      var events = this.getEvents(eventName);

      for (var i = 0; i < events.length; i++) {
        if (events[i].callback === callback) {
          return true;
        }
      }
    }

    return false;
  };

  EventEmitter.prototype.getEvents = function (eventName) {
    if (this.checkEventNameExist(eventName)) {
      return this._eventMap[eventName];
    }
  };

  EventEmitter.prototype.on = function (eventName, callback) {
    if (!this.checkEventNameExist(eventName)) {
      this._eventMap[eventName] = [];
    }

    this._eventMap[eventName].push({
      callback: callback,
      isOnce: false
    });
  };

  EventEmitter.prototype.off = function (eventName, callback) {
    if (this.checkCallbackExist(eventName, callback)) {
      var events = this.getEvents(eventName);

      for (var i = 0; i < events.length; i++) {
        if (events[i].callback === callback) {
          events.splice(i, 1);
        }
      }
    }
  };

  EventEmitter.prototype.once = function (eventName, callback) {
    if (!this.checkEventNameExist(eventName)) {
      this._eventMap[eventName] = [];
    }

    this._eventMap[eventName].push({
      callback: callback,
      isOnce: true
    });
  };

  EventEmitter.prototype.emit = function (eventName, data) {
    if (data === void 0) {
      data = {};
    }

    if (this.checkEventNameExist(eventName)) {
      var events = this._eventMap[eventName];

      for (var i = 0; i < events.length; i++) {
        var event_1 = events[i];
        event_1.callback(data);

        if (event_1.isOnce) {
          events.splice(i, 1);
        }
      }
    }
  };

  EventEmitter.prototype.remove = function (eventName) {
    delete this._eventMap[eventName];
  };

  return EventEmitter;
}();

var DESCRIPTORS = descriptors;
var fails = fails$h;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$6;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

/**
 * @category utils
 * @description thunder打点用的类，单例模式实现
 */

var Thunder = function () {
  function Thunder(params) {
    if (params === void 0) {
      params = {};
    }

    this.baseUrl = 'https://hpd.baidu.com/v.gif';
    this.baseParams = params || {};
  }
  /**
   * 发送打点
   * @param params 打点参数
   */


  Thunder.prototype.send = function (params) {
    var sendParams = Object.assign({}, this.baseParams, params);
    var image = new Image();
    image.src = this.baseUrl + '?' + paramsToString(sendParams);
  };
  /**
   * 更新基础打点参数
   * @param params
   */


  Thunder.prototype.updateBaseParams = function (params) {
    Object.assign(this.baseParams, params);
  };

  return Thunder;
}();
var thunder = new Thunder();

/**
 * @class TtsPlayer
 */

var TtsPlayer = function () {
  function TtsPlayer(options) {
    this._ownEmitter = new EventEmitter();

    this._bindEmitEvents();

    this.ui = new TtsPlayerUI(options.uiOptions, this._ownEmitter);
    this.core = new TtsPlayerCore(options.coreOptions, this._ownEmitter);
    this._logOptions = options.logOptions;
    this.initLog();
    this.events = new EventEmitter();
    this.inited = false;
    this.initing = false;
    this._initPromise = null;
    this.version = '0.3.3';

    this._bindLogEvents();
  }
  /**
   * 接收开发者需要的core及ui事件，统一透传出去
   */


  TtsPlayer.prototype._bindEmitEvents = function () {
    var _this = this;

    this._ownEmitter.on(CoreEvents.CHANGE_PARAGRAPH, function (index) {
      _this.events.emit(PlayerEvents.CHANGE_PARAGRAPH, index);
    });

    this._ownEmitter.on(CoreEvents.CHANGE_ID, function () {
      _this.events.emit(CoreEvents.CHANGE_ID);
    });

    this._ownEmitter.on(PlayerUIEvents.CONTINUE_CLICK, function (data) {
      _this.events.emit(PlayerEvents.PLAY_CLICK, data);
    });

    this._ownEmitter.on(PlayerUIEvents.PAUSE_CLICK, function (data) {
      _this.events.emit(PlayerEvents.PAUSE_CLICK, data);
    });

    this._ownEmitter.on(PlayerUIEvents.CLICK_TITLE, function () {
      _this.events.emit(PlayerEvents.CLICK_TITLE, _this.core.curPlayItem);
    });

    this._ownEmitter.on(PlayerUIEvents.CLOSE_CLICK, function () {
      _this.ui.hide();

      _this.core.pause();
    });

    this._ownEmitter.on(CoreEvents.LOAD_VOICES, function (data) {
      _this.ui.initVoiceList(data);
    });

    this._ownEmitter.on(CoreEvents.PLAY_END, function (data) {
      _this.events.emit(PlayerEvents.PLAY_END, data);
    });

    this._ownEmitter.on(CoreEvents.START_PLAY, function (data) {
      _this.events.emit(PlayerEvents.START_PLAY, data);
    });

    this._ownEmitter.on(CoreEvents.PLAY, function (data) {
      _this.events.emit(PlayerEvents.PLAY, data);

      _this.ui.show();
    });

    this._ownEmitter.on(CoreEvents.PAUSE, function (data) {
      _this.events.emit(PlayerEvents.PAUSE, data);
    });

    this._ownEmitter.on(CoreEvents.ERROR, function (data) {
      _this.events.emit(PlayerEvents.ERROR, data);
    });
  };
  /**
   * 绑定日志事件
   * @private
   */


  TtsPlayer.prototype._bindLogEvents = function () {
    var _this = this;

    this._ownEmitter.on(CoreEvents.PLAY_END, function () {
      _this.sendDurationLog();
    });

    this._ownEmitter.on(CoreEvents.PAUSE, function () {
      _this.sendDurationLog();
    });

    this._ownEmitter.on(CoreEvents.CHANGE_ID, function () {
      _this.sendDurationLog();
    });

    this._ownEmitter.on(CoreEvents.START_PLAY, function () {
      _this._startTime = new Date().getTime();
    });

    this._ownEmitter.on(PlayerUIEvents.CONTINUE_CLICK, function () {
      _this.sendLog(LOG_TYPE.CLICK, 'tts_play_button', 'play');

      _this._startTime = new Date().getTime();
    });

    this._ownEmitter.on(PlayerUIEvents.PAUSE_CLICK, function () {
      _this.sendLog(LOG_TYPE.CLICK, 'tts_play_button', 'pause');
    });

    this._ownEmitter.on(PlayerUIEvents.NEXT_CLICK, function () {
      _this.sendLog(LOG_TYPE.CLICK, 'tts_next_button');
    });

    this._ownEmitter.on(PlayerUIEvents.VOICE_CHANGE_CLICK, function () {
      _this.sendLog(LOG_TYPE.CLICK, 'tts_voice_change');
    });

    this._ownEmitter.on(PlayerUIEvents.VOICE_COLUMN_CLICK, function () {
      _this.sendLog(LOG_TYPE.CLICK, 'tts_volume');
    });

    this._ownEmitter.on(PlayerUIEvents.CLICK_TITLE, function () {
      _this.sendLog(LOG_TYPE.CLICK, 'tts_news_title');
    });

    this._ownEmitter.on(PlayerUIEvents.CLOSE_CLICK, function () {
      _this.sendLog(LOG_TYPE.CLICK, 'tts_player_close');
    });

    this._ownEmitter.on(PlayerUIEvents.VOICE_CHOOSE, function (voiceItem) {
      _this.sendLog(LOG_TYPE.CLICK, voiceItem.speakerId, voiceItem.isSelected ? 'choose' : 'cancel');
    });

    this._ownEmitter.on(PlayerUIEvents.SHOW_PLAYER, function () {
      _this.sendLog(LOG_TYPE.SHOW, 'tts_player_show');
    });
  };
  /**
   * 暂停播放
   */


  TtsPlayer.prototype.pause = function () {
    this.core.pause();
  };
  /**
   * 暂停后的继续播放
   */


  TtsPlayer.prototype.continue = function () {
    this.core.continue();
  };
  /**
   * 隐藏播放器
   */


  TtsPlayer.prototype.hide = function () {
    var _this = this;

    this.init().then(function () {
      _this.ui.hide();

      _this.core.pause();
    });
    this.ui.hide();
    this.core.pause();
  };
  /**
   * 展示播放器
   */


  TtsPlayer.prototype.show = function () {
    var _this = this;

    this.init().then(function () {
      _this.ui.show();
    });
  };
  /**
   * 初始化播放器
   */


  TtsPlayer.prototype.init = function () {
    var _this = this;

    if (this.inited || this.initing) {
      return this._initPromise;
    }

    if (!TtsPlayerCore.isSupport()) {
      return Promise.reject('player is not support this browser');
    }

    this.initing = true;
    this._initPromise = this.core.loadVoices().then(function () {
      _this.initing = false;
      _this.inited = true;
    }).catch(function (e) {
      debugError('获取音色列表失败', e);
    });
    return this._initPromise;
  };
  /**
   * 发送时长日志
   */


  TtsPlayer.prototype.sendDurationLog = function () {
    if (this._logOptions && this._logOptions.durationTid && this.core.curPlayItem) {
      var extraParams = this.core.curPlayItem.logParams || {};
      var duration = Math.round((Date.now() - this._startTime) / 1000);

      if (duration === 0) {
        return;
      }

      thunder.send({
        tid: this._logOptions.durationTid,
        logInfo: 'tts_play',
        cst: LOG_TYPE.DURATION,
        ct: '2',
        r: Date.now(),
        startTime: this._startTime,
        endTime: Date.now(),
        nid: this.core.curPlayItem.id,
        duration: duration,
        logExtra: encodeURIComponent(JSON.stringify(__assign({
          type: this.core.curVoiceItem.speakerId
        }, extraParams)))
      }); // 一次startTime使用完成后重置下时间，避免重复上报

      this._startTime = new Date().getTime();
    }
  };
  /**
   * 发送打点日志
   * @param logType 日志类型
   * @param type 打点type
   * @param value 打点value
   */


  TtsPlayer.prototype.sendLog = function (logType, type, value) {
    if (type === void 0) {
      type = '';
    }

    if (value === void 0) {
      value = '';
    }

    if (!this._logOptions) {
      return;
    }

    var tid = '';
    var logInfo = '';

    switch (logType) {
      case LOG_TYPE.CLICK:
        tid = this._logOptions.clickTid;
        logInfo = 'tts_click';
        break;

      case LOG_TYPE.SHOW:
        tid = this._logOptions.showTid;
        logInfo = 'tts_show';
        break;
    }

    var extraParams = this.core.curPlayItem && this.core.curPlayItem.logParams || {};
    thunder.send({
      tid: tid,
      logInfo: logInfo,
      cst: logType,
      ct: '2',
      logExtra: encodeURIComponent(JSON.stringify(__assign({
        type: type,
        value: value
      }, extraParams))),
      r: Date.now()
    });
  };
  /** 初始化打点 */


  TtsPlayer.prototype.initLog = function () {
    var logOptions = this._logOptions;

    if (!logOptions) {
      logOptions = {
        logFrom: '',
        clickTid: '',
        sid: '',
        showTid: '',
        durationTid: ''
      };
    }

    thunder.updateBaseParams({
      logFrom: logOptions.logFrom || '',
      ct: 2,
      sid: logOptions.sid,
      ssid: '',
      logid: ''
    });
  };
  /**
   * 添加资源到播放列表
   * @param sourceItems 资源列表
   */


  TtsPlayer.prototype.addItems = function (sourceItems) {
    return this.core.addItems(sourceItems);
  };
  /**
   * 播放指定资源
   * @param id 资源id
   */


  TtsPlayer.prototype.playItem = function (id) {
    var _this = this;

    return this.init().then(function () {
      _this.core.play(id);
    });
  };
  /**
   * 播放下一首
   */


  TtsPlayer.prototype.playNext = function () {
    return this.core.playNext();
  };
  /**
   * 渲染播放器
   */


  TtsPlayer.prototype.render = function () {
    var _this = this;

    this.init().then(function () {
      _this.ui.render();
    });
  };
  /**
   * 监听事件
   * @param args 回调参数
   */


  TtsPlayer.prototype.on = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return this.events.on.apply(this.events, args);
  };
  /**
   * 关闭事件
   * @param args
   */


  TtsPlayer.prototype.off = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return this.events.off.apply(this.events, args);
  };
  /**
   * 监听事件，只触发一次
   * @param args
   */


  TtsPlayer.prototype.once = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return this.events.once.apply(this.events, args);
  };
  /**
   * 修改位置
   * @param position
   */


  TtsPlayer.prototype.editPosition = function (position) {
    this.ui.editPosition(position);
  };
  /**
   * 更新资源，原有资源会被全部删掉
   * @param sourceItems
   */


  TtsPlayer.prototype.updateItems = function (sourceItems) {
    this.core.updateItems(sourceItems);
  };

  return TtsPlayer;
}();

export { TtsPlayer };
